import { HttpClient } from '@angular/common/http';

import {
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    AfterViewInit,
    Inject,
    PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MainBodyService } from '../../../services/main-body.service';
import { responsedata, themeData } from 'src/interface/themesetting';
import {
    articleDetail,
    articleOutline,
    authors_data,
    downloadFile,
    favourites,
    imagePaths,
    navigationobject,
    tableOverview,
    timelineEvents,
} from 'src/interface/article';
import { EnvService } from '../../../services/env.service';
import { GetArticlesService } from '../../../services/get-articles.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { Subject, Subscription, filter } from 'rxjs';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Meta } from '@angular/platform-browser';
import { JournalService } from '../../journal.service';
import { FavouriteService } from 'src/app/services/favourite.service';
import { Title } from '@angular/platform-browser';
import { AlertService } from 'src/app/services/alert.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
declare let gtag: Function;
declare let _altmetric_embed_init: any;
declare let __dimensions_embed: any;
declare let Crossmark: any;
import axios from 'axios';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-article-view-page',
    templateUrl: './article-view-page.component.html',
    styleUrls: ['./article-view-page.component.scss'],

})
export class ArticleViewPageComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('article') articleContent!: ElementRef<HTMLDivElement>;
    @ViewChild('scrollToTop') scrollToTop!: ElementRef<HTMLButtonElement>;
    @ViewChild('contentLoaded') contentLoaded!: ElementRef<HTMLDivElement>;
    @ViewChild('articleOutlin') articleOutlin: ElementRef<HTMLDivElement>;
    @ViewChild('citation') citation: ElementRef<HTMLParagraphElement>;
    @ViewChild('modalData') modalData: ElementRef<HTMLElement>;
    @ViewChild('articleView') articleView: ElementRef<HTMLElement>;
    @ViewChild('articleHead') articleHead: ElementRef<HTMLDivElement>;
    @ViewChild('articleAbstract') articleAbstract: ElementRef<HTMLDivElement>;
    @ViewChild('ImagesOutlin') imagesOutlin: ElementRef<HTMLDivElement>;
    @ViewChild('dimensionDiv') dimensionDiv: ElementRef<HTMLDivElement>;
    @ViewChild('articleViewBox') articleViewBox: ElementRef<HTMLDivElement>;
    @ViewChild('listContent3') listContent3: ElementRef<HTMLDivElement>;
    @ViewChild('listContent2') listContent2: ElementRef<HTMLDivElement>;
    @ViewChild('listContent1') listContent1: ElementRef<HTMLDivElement>;
    @ViewChild('myTabContent') myTabContent: ElementRef<HTMLDivElement>;
    @ViewChild('basicInfo') basicInfoDiv: ElementRef<HTMLDivElement>;
    @ViewChild('keyword') keywordDiv: ElementRef<HTMLDivElement>;
    @ViewChild('audiobuttons') audiobuttons: ElementRef<HTMLDivElement>;
    @ViewChild('articleOutlinecol') articleOutlinecol: ElementRef<HTMLDivElement>;
    @ViewChild('articleViewContents') htmlContent: ElementRef<HTMLDivElement>;
    @ViewChild('scrollingTitleSection') scrollingTitleSection: ElementRef<HTMLDivElement>;
    @ViewChild('refContentDiv') refContentDiv: ElementRef<HTMLDivElement>;

    @ViewChild('aricleContentArea') aricleContentArea: ElementRef<HTMLDivElement>;
    @ViewChild('articleContentAreaColumn') articleContentAreaColumn: ElementRef<HTMLDivElement>
    // @ViewChild('expantooltip') expantooltip: ElementRef;
    @ViewChild('stop', { static: true, read: ElementRef })
    btnStop!: ElementRef<HTMLButtonElement>;

    @ViewChild('speak', { static: true, read: ElementRef })
    btnSpeak!: ElementRef<HTMLButtonElement>;

    textChanged$ = new Subject<void>();
    subscription = new Subscription();
    msg: string[] = [];

    filename: string;
    issue: string;
    activeline: boolean[] = [];
    activebutton: boolean[];
    articlelist: articleDetail;
    authors: authors_data[] = [];
    articleHtml = '';
    parser: DOMParser;
    articleOutline: articleOutline[] = [];
    themeSettingsData: themeData;
    journalId: string;
    clickedstatus = false;
    clickedPos = 0;
    envpath = '';
    defaultArticleCover = '';
    articleImagePath = '';
    articleCoverImageUrl = '';
    // journalSubscription: Subscription;
    // themeSubscription: Subscription;
    // articleViewSubscription: Subscription;
    decodedText: string;
    encodedText: string;
    tooltipStatus = '';
    modalclose = '';
    heading = '';
    caption = '';
    body = '';
    enable = false;
    authorStatus = '';
    breakStat = false;
    downloadPath = '';
    journal_id = '';
    volume_id = '';
    issue_id = '';
    article_id = '';
    isScrolling = false;
    scrollEndTimeout;
    disableBtnPdf = true;
    disableBtnXml = true;
    downloading: boolean;
    downloadingData: { filename: string; download: boolean }[] = [];
    downloadProgress = 0;
    downloadCount = -1;
    fasttrack: boolean;
    articleTimeLine: [];
    isCopied = false;
    imageModal = false;
    CoverImageModal = false;
    citeModal = false;
    modalHrefContent = ''
    modalcurrentSrc = ''
    modalContent = ''
    imagePaths: imagePaths[] = []
    videoPaths: imagePaths[] = []
    clipPaths: imagePaths[] = []
    tableOverview: tableOverview[] = []
    activeTab = 'tab1';
    loaderStatus = true;
    viewActiveIcon = 'normal';
    schema = {};
    loading = true;
    keywordContent = new Array(3).fill(0);
    abstractcontentloader = new Array(7).fill(0);
    recentArticles = new Array(2).fill(0);
    sharedUrl = '';
    titleShared: string;
    expanded = false;
    expandTootlipMsg: string;
    titleMsg: boolean;
    referenceData: Element;
    // private msgSubject = new BehaviorSubject<string>('Initial message');
    toggleOutline = false;
    cite: string;
    fn_group = false;
    articleContenteAreaWidth: number;
    breadCrumbNavigation: navigationobject[]
    toggle_favourite: any;
    subscriptionArr: Subscription[] = [];
    showFavoritesBtn = false;
    headerHeight = 0;
    hideExpanIcon = false;
    footerHeight = 0;
    contentAreaHeight: number;
    initialArticleCount = 2;
    totalArticles = 0;
    showLessFlag = false;
    loadMoreFlag = false;
    intialarticleCountInTab = 2;
    showLessFlagTab = false;
    loadMoreFlagTab = false;
    default_article_cover_image_upto_11: string;
    default_article_cover_image_above_11: string;
    aricleContentAreaWidth = 0;
    supplementaryFilesPath = '';
    referenceContent: boolean;
    headingSectionDivLeft = 0;
    pdfPath = '';
    pdfExit = false;
    pdfNotexist = '';
    viewCount = 0;
    pdf_body_button = false;
    private readonly TRACKED_ARTICLES_KEY = 'trackedarticles';
    constructor(
        public mainBodyService: MainBodyService,
        private articleService: GetArticlesService,
        private http: HttpClient,
        public env: EnvService,
        private route: ActivatedRoute,
        private router: Router,
        private sharedService: SharedService,
        public renderer: Renderer2,
        private location: Location,
        private modalservice: NgbModal,
        private meta: Meta,
        private journalService: JournalService,
        private favouriteService: FavouriteService,
        private titleService: Title,
        @Inject(PLATFORM_ID) private platformId: any,
        private alertService: AlertService,
        private analytics: GoogleAnalyticsService,
        @Inject(DOCUMENT) private document: Document

    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.parser = new DOMParser();

        }
        this.addJsToElement('https://badge.dimensions.ai/badge.js', 'text/javascript');
        this.addJsToElement('https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js', 'text/javascript');
        // this.addJsToElement("https://cdn.scite.ai/badge/scite-badge-latest.min.js", 'text/javascript');
        // this.addJsToElement('https://crossmark-cdn.crossref.org/widget/v2.0/widget.js', 'text/javascript');

        this.addJsToElement('assets/js/mathjaxconfig.js', 'text/x-mathjax-config');
        this.addJsToElement('assets/js/mathjaxconfig_other.js', 'text/javascript');
        this.addJsToElement('assets/js/confin_other.js', 'text/x-mathjax-config');
        this.addJsToElement('https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_HTMLorMML', 'text/javascript');

        const journalType = { jnl_type: "JNL" }
        const journalSubscription = this.sharedService
            .getJournalId()
            .subscribe(() => {
                const journal_id = this.route.snapshot.params['journal_id'];
                this.journalId = journal_id;
                if (this.journalId == undefined)
                    this.journalService.getJournals(journalType).subscribe((result) => {
                        // this.journal_id = result.data[0].id;
                        this.journalId = result.data[0].id;
                    });
            });
        this.subscriptionArr.push(journalSubscription);
        this.envpath = this.env.articleUrl;
        this.articlelist = {
            abstract: '',
            art_file_path: '',
            article_cover_image: '',
            cover_alt_text: '',
            article_id: '',
            article_title: '',
            article_type: '',
            subject_heading: '',
            article_timeline: [
                {
                    year: '',
                    date: '',
                    month: '',
                    type: '',
                },
            ],
            authors: [
                {
                    affiliations: [],
                    corresp: [],
                    corresp_author: '',
                    credit_taxonomy: [],
                    email: '',
                    given_name: '',
                    orcid: '',
                    surname: '',
                    notes: [],
                    specific_use: ''
                },
            ],
            copyright_statement: '',
            copyright_year: '',
            doi: '',
            e_issn: '',
            html_content: '',
            id: {
                $oid: '',
            },
            issue_id: '',
            journal_display_name: '',
            journal_id: '',
            journal_title: '',
            page_end: '',
            page_start: '',
            published_date: '',
            publisher_name: '',
            volume_id: '',
            year: '',
            fpage: '',
            lpage: '',
            keywords: [],
            view_count: 0,
            download_count: 0,
            supplementary_files: [],
            license: '',
            license_type: '',
            citation_author: '',
            left_running_head: '',
            right_running_head: '',
            publisher_loc: ''
        };
        const segments = this.route.url.subscribe((segments) => {
            if (segments.some((segment) => segment.path === 'fasttrack')) {
                this.fasttrack = true;
            } else {
                this.fasttrack = false;
            }
        });
        this.subscriptionArr.push(segments);
        const routesub = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateBreadcrumb();
        });
        this.subscriptionArr.push(routesub);
    }
    timelineEvents: timelineEvents[] = [
        { date: 'October 2022', description: 'Received', outlineId: '0' },
        { date: 'May 2023', description: 'Accepted', outlineId: '0' },
        { date: 'July 2023', description: 'Published', outlineId: '0' }
    ];
    private trackArticleViewOnce(): void {
        if (isPlatformBrowser(this.platformId)) {
            const url = this.router.url
            const trackedJournals = JSON.parse(sessionStorage.getItem(this.TRACKED_ARTICLES_KEY) || '[]');
            if (!trackedJournals.includes(url)) {
                gtag('event', 'page_view', {
                    page_path: url
                });
                trackedJournals.push(url);
                sessionStorage.setItem(this.TRACKED_ARTICLES_KEY, JSON.stringify(trackedJournals));
            }
        }
    }

    ngOnInit(): void {
        this.trackArticleViewOnce()
        this.default_article_cover_image_upto_11 = this.env.default_article_cover_image_upto_11;
        this.default_article_cover_image_above_11 = this.env.default_article_cover_image_above_11;
        this.route.params.subscribe((params: any) => {
            this.sharedService.setUrlParams(params);
            // if (params.preview_mode) {
            //     this.expanded = true;
            //     this.hideExpanIcon = true;
            // }
            // else {
            //     this.hideExpanIcon = false
            // }

        })
        // if (window.location.hash) {
        //     const fragment = window.location.hash.substring(1);

        //     const secEle = document.querySelector("[id='" + fragment + "']");

        //     setTimeout(() => {

        //         const element = document.getElementById(fragment);
        //         if (element) {
        //             window.scrollTo({
        //                 top: element.offsetTop + 600,
        //                 behavior: 'smooth',
        //             });
        //         }
        //     }, 500);

        // }

        const journalType = { jnl_type: "JNL" }
        if (this.route.params['journal_id'] == undefined) {

            const journalsubs = this.journalService.getJournals(journalType).subscribe((result) => {
                // this.journal_id = result.data[0].id;
                this.journalId = result.data[0].id;

                this.articleInitialLoad();
                setTimeout(() => {
                    this.loaderStatus = false;
                }, 1000);

                this.addJsToElement('https://badge.dimensions.ai/badge.js', 'text/javascript');
                this.addJsToElement('https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js', 'text/javascript');
                // this.addJsToElement('https://cdn.scite.ai/badge/scite-badge-latest.min.js', 'text/javascript');
                // this.addJsToElement('https://crossmark-cdn.crossref.org/widget/v2.0/widget.js', 'text/javascript');
                this.route.params.subscribe(() => {
                    this.articleInitialLoad();
                });
                const scritesubs = this.articleService.scite_badge_hover.subscribe(result => {
                    if (result) {
                        this.htmlContent.nativeElement.classList.remove('z-index');
                    }
                    if (!result) {
                        setTimeout(() => {
                            this.htmlContent.nativeElement.classList.add('z-index');
                        }, 1000);
                    }
                })
                this.subscriptionArr.push(scritesubs);
            });
            this.subscriptionArr.push(journalsubs);
        }
        else {
            this.addJsToElement('https://badge.dimensions.ai/badge.js', 'text/javascript');
            this.addJsToElement('https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js', 'text/javascript');
            // this.addJsToElement('https://cdn.scite.ai/badge/scite-badge-latest.min.js', 'text/javascript');
            // this.addJsToElement('https://crossmark-cdn.crossref.org/widget/v2.0/widget.js', 'text/javascript');
            this.route.params.subscribe(() => {
                this.articleInitialLoad();
            });
            const bagesubs = this.articleService.scite_badge_hover.subscribe(result => {
                if (result) {
                    this.htmlContent.nativeElement.classList.remove('z-index');
                }
                if (!result) {
                    setTimeout(() => {
                        this.htmlContent.nativeElement.classList.add('z-index');
                    }, 1000);
                }
            })
            this.subscriptionArr.push(bagesubs);
        }
        const firstChild = this.myTabContent?.nativeElement.children[0] as HTMLElement;
        if (firstChild) {
            firstChild.style.width = '100%!important';
            firstChild.style.overflowX = 'scroll';
        }
        setTimeout(() => {
            this.onWindowScroll()
        }, 3000);

    }

    ngAfterViewInit() {
        // this.articleInitialLoad();
        if (isPlatformBrowser(this.platformId)) {

            const windowHeight = window.innerHeight
            const divHeight1 = this.listContent1?.nativeElement.clientHeight
            const divHeight2 = this.listContent2?.nativeElement.clientHeight
            const divHeight3 = this.listContent3?.nativeElement.clientHeight
            let outerHeight = 0;
            if (divHeight2) {
                outerHeight = divHeight1 + divHeight2 + divHeight3
            }
            else
                outerHeight = divHeight1 + divHeight3
            const pageOutlineHeight = windowHeight - outerHeight - 150

            if (this.myTabContent) {
                this.myTabContent.nativeElement.style.height = pageOutlineHeight + 'px';
                this.myTabContent.nativeElement.style.height = pageOutlineHeight + 'px';
                const firstChild = this.myTabContent.nativeElement.children[0] as HTMLElement;
                if (firstChild) {
                    firstChild.style.width = '100%!important';
                    firstChild.style.overflowX = 'scroll';
                }

            }
            if (document.getElementById('header'))
                this.headerHeight = document.getElementById('header')?.offsetHeight as number;
            // this.footerHeight = document.getElementById('footer')?.offsetHeight as number;
            // if (this.articleView.nativeElement.offsetHeight < 900) {
            //     this.contentAreaHeight = window.innerHeight - (this.headerHeight + this.footerHeight);
            // }
            this.aricleContentAreaWidth = this.aricleContentArea?.nativeElement.offsetWidth;
            if (window.innerWidth <= 600) {
                this.aricleContentAreaWidth = this.aricleContentArea?.nativeElement.offsetWidth - 55;
            }
            setTimeout(() => {
                this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'width', (this.htmlContent?.nativeElement.offsetWidth + 15) + 'px');
                this.headingSectionDivLeft = window.innerWidth <= 612 ? 30 : (this.articleOutlinecol?.nativeElement.offsetWidth ?? 0) + 70;
            }, 3000);
            //    setTimeout(() => {
            //     this.referenceContent=  this.articleContent.nativeElement.getElementsByClassName("ref-list")?true:false;
            //    }, 1000);


        }
        this.analytics.getAnalytics().subscribe((result: any) => {
            let currentUrl = this.router.url;
            if (Array.isArray(result)) {
                const filteredData = result.filter(item =>
                    item.dimensionValues[0].value === currentUrl
                );
                if (filteredData.length > 1) {
                    const pageViews = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'page_view') && item.dimensionValues[0].value.includes('article'));
                    const downloads = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'download') && item.dimensionValues[0].value.includes('article'));
                    this.downloadCount = downloads[0].metricValues[0].value
                    this.viewCount = pageViews[0].metricValues[0].value
                }
            }
        })
    }
    scrollToPreviousSection() {
        if (isPlatformBrowser(this.platformId)) {
            const data: any = this.route.fragment;
            const fragment: string = data._value as string;
            if (fragment) {

                document.querySelector("[id='" + fragment + "']");
                setTimeout(() => {
                    const element = document.getElementById(fragment);
                    if (element) {
                        window.scrollTo({
                            top: element.offsetTop + 480,
                            behavior: 'smooth',
                        });
                    }
                }, 500);
            }
        }
    }
    updateBreadcrumb(): void {
        this.breadCrumbNavigation = [];
        const urlSegments = this.router.url.split('/').filter(segment => segment !== '');
        let url = '';

        urlSegments.forEach(segment => {
            url += `/${segment}`;
            this.breadCrumbNavigation.push({ identifier: segment, url: url as string });
        });

    }
    articleInitialLoad() {
        this.fn_group = false;
        //this.journal_id = this.route.snapshot.params['journal_id'];
        this.journal_id = this.journalId;
        this.volume_id = this.route.snapshot.params['volume_id'];
        this.issue_id = this.route.snapshot.params['issue_id'];
        if (this.volume_id == '0') {
            this.fasttrack = true;
        }
        this.article_id = this.route.snapshot.params['article_id'];
        const favourite_match: favourites = {
            jnl_id: this.journal_id,
            volume: this.volume_id,
            issue: this.issue_id,
            article_id: this.article_id
        }
        this.toggle_favourite = this.favouriteService.getFavourite(favourite_match);
        this.downloadPath = this.env.downloadFilePath;
        this.defaultArticleCover =
            this.env.defaultImagePath + this.env.default_articleCoverImage;
        this.articleCoverImageUrl =
            this.env.articleCoverImage + this.journal_id + '/';
        this.mainBodyService.urlchange(true);
        const themeSubscription = this.mainBodyService
            .getAllThemeSettings(this.journal_id)
            .subscribe((result: responsedata) => {
                this.themeSettingsData = result.data;
                const color = this.themeSettingsData.theme_colors;
                if (color) {
                    if (isPlatformBrowser(this.platformId)) {
                        Object.entries(color).map(([key, value]) => {
                            const element = '--' + key;
                            const val: string = value;
                            document.documentElement.style.setProperty(
                                element,
                                val
                            );
                        });
                    }
                }
            });
        this.subscriptionArr.push(themeSubscription);
        if (this.articleOutline) {
            this.activeline = [];
            this.activeline[0] = true;
            this.activebutton = [];
            this.activebutton[0] = true;
        }
        // Extract the encodedText from the parameters
        this.encodedText = this.route.snapshot.params['preview_mode'] ? this.route.snapshot.params['preview_mode'] : '';

        // Check if encodedText is defined
        if (this.encodedText != undefined) {
            // Decode the encodedText
            // const decodedText = window.atob(this.encodedText);

            // Check if decodedText is "true"
            // const text =
            //     this.volume_id +
            //     '/' +
            //     this.issue_id +
            //     '/' +
            //     this.article_id;
            // if (decodedText == text) {
            // Extract the remaining parameters
            const queryParams = {
                journal_id: this.journal_id,
                volume_id: this.volume_id,
                issue_id: this.issue_id,
                article_id: this.article_id,
                preview_mode: this.encodedText,
            };
            //to get the htmlcontent of the article

            const articleViewSubscription = this.articleService
                .getArticleView(queryParams)
                .subscribe((result: any) => {
                    if (result.data.length === 0)
                        this.router.navigate(['/**']);

                    this.loading = false;
                    this.articlelist = result.data;
                    this.supplementaryFilesPath = this.env.articleImage + this.articlelist.art_file_path
                    this.titleService.setTitle(this.getCleanTitle(this.articlelist.article_title) + ' | ' + this.articlelist.journal_title);
                    this.createMetadataforSEONew(this.articlelist)
                    if (this.articlelist)
                        this.articleViewCount(this.articlelist);

                    this.schema = {
                        '@context': 'http://schema.org',
                        '@type': 'ScholarlyArticle',
                        "headline": this.articlelist.article_title.replace(/<[^>]*>/g, ''),
                        "datePublished": this.articlelist.published_date,
                        'url': this.env.siteUrl + 'articles/' + this.articlelist.article_id,
                        'image': this.env.articleCoverImage + this.articlelist.article_cover_image,
                        "publisher": {
                            "@type": "Organization",
                            "name": "River Valley Technologies Ltd",
                            "logo": {
                                "@type": "ImageObject",
                                "url": this.env.siteUrl + 'admin/apis/public/assets/rvtlogos.png'
                            }
                        }
                    }
                    if (isPlatformBrowser(this.platformId)) {
                        this.injectJsonLd(this.schema);
                    }
                    if (this.articlelist.article_id) {
                        this.disableBtnPdf = false;
                        this.disableBtnXml = false;
                        this.loading = false;
                        if (this.articlelist)
                            this.articleViewCount(this.articlelist);
                        this.restructureArticleHtml(
                            this.articlelist.html_content
                        );
                        setTimeout(() => {
                            if (typeof _altmetric_embed_init === 'function') {
                                _altmetric_embed_init();
                            }
                            if (typeof __dimensions_embed !== 'undefined' && __dimensions_embed.addBadges) {
                                __dimensions_embed.addBadges();
                            }
                            // if (typeof Crossmark !== 'undefined' && Crossmark.init) {
                            //     Crossmark.init();
                            // } else {
                            //     // Fallback: try to find the script and re-run it or wait
                            //     setTimeout(() => {
                            //         if (typeof Crossmark !== 'undefined' && Crossmark.init) {
                            //             Crossmark.init();
                            //         }
                            //     }, 2000);
                            // }
                        }, 1000);

                    } else {
                        this.disableBtnPdf = true;
                        this.disableBtnXml = true;
                        this.router.navigate(['/page-not-found/404']);
                    }
                });
            this.subscriptionArr.push(articleViewSubscription);
            // } else {
            // Handle the case when decodedText is not "true"
            // this.router.navigate(['/**']);
            // }
        }
        //  else {
        //     // Handle the case when encodedText is undefined
        //     const queryParams = {
        //         journal_id: this.journalId,
        //         volume_id: this.volume_id,
        //         issue_id: this.issue_id,
        //         article_id: this.article_id,
        //         preview_mode: '',
        //     };
        //     //to get the htmlcontent of the article
        //     const articleViewSubscription = this.articleService
        //         .getArticleView(queryParams)
        //         .subscribe((result: any) => {
        //             if (result.data.length === 0)
        //                 // this.router.navigate(['/**']);

        //                 this.loading = false;
        //             this.articlelist = result.data;

        //             this.supplementaryFilesPath = this.env.articleImage + this.articlelist.art_file_path
        //             this.titleService.setTitle(this.getCleanTitle(this.articlelist.article_title) + ' | ' + this.articlelist.journal_title);
        //             this.createMetadataforSEONew(this.articlelist)
        //             //this.articleTimeLine=this.articlelist['article_timeline'];
        //             if (this.articlelist.article_id) {
        //                 this.disableBtnPdf = false;
        //                 this.disableBtnXml = false;
        //                 if (this.articlelist)
        //                     this.articleViewCount(this.articlelist);
        //                 this.restructureArticleHtml(
        //                     this.articlelist.html_content
        //                 );
        //             } else {
        //                 this.disableBtnPdf = true;
        //                 this.disableBtnXml = true;
        //                 // this.router.navigate(['/page-not-found/404']);
        //             }
        //         });
        //     this.subscriptionArr.push(articleViewSubscription);
        // }
        this.fetchDataFromApi(this.article_id);

        this.addJsToElement('assets/js/mathjaxconfig.js', 'text/x-mathjax-config');
        this.addJsToElement('assets/js/mathjaxconfig_other.js', 'text/javascript');
        this.addJsToElement('assets/js/confin_other.js', 'text/x-mathjax-config');
        this.addJsToElement('https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_HTMLorMML', 'text/javascript');

    }
    articleViewCount(article_data: articleDetail) {
        if (isPlatformBrowser(this.platformId)) {
            const sessionData = sessionStorage.getItem('article_view_count');
            const parseData = sessionData
                ? JSON.parse(sessionData)
                : { journals: [] };
            const targetArticleId = article_data.article_id;
            const targetJournalId = article_data.journal_id;
            const targetVolumeId = article_data.volume_id;
            const targetIssueId = article_data.issue_id;
            // Helper function to check if an article_id exists in the given issue
            for (const journal of parseData.journals) {
                if (journal.journal_id === targetJournalId) {
                    for (const volume of journal.volumes) {
                        if (volume.volume_id === targetVolumeId) {
                            for (const issue of volume.issues) {
                                if (issue.issue_id === targetIssueId) {
                                    if (
                                        !this.articleExistsInIssue(
                                            issue,
                                            targetArticleId
                                        )
                                    ) {
                                        issue.articles.push(targetArticleId);
                                        this.setSessionData(
                                            parseData,
                                            article_data
                                        );
                                    }
                                    return; // Exit the loop when issue is found
                                }
                            }
                            // If issue doesn't exist, add it
                            volume.issues.push({
                                issue_id: targetIssueId,
                                articles: [targetArticleId],
                            });
                            this.setSessionData(parseData, article_data);
                            return; // Exit the loop when volume is found
                        }
                    }
                    // If volume doesn't exist, add it
                    journal.volumes.push({
                        volume_id: targetVolumeId,
                        issues: [
                            {
                                issue_id: targetIssueId,
                                articles: [targetArticleId],
                            },
                        ],
                    });
                    this.setSessionData(parseData, article_data);
                    return; // Exit the loop when journal is found
                }
            }

            // If journal doesn't exist, add it
            parseData.journals.push({
                journal_id: targetJournalId,
                volumes: [
                    {
                        volume_id: targetVolumeId,
                        issues: [
                            {
                                issue_id: targetIssueId,
                                articles: [targetArticleId],
                            },
                        ],
                    },
                ],
            });

            // this.setSessionData(parseData, article_data);
        }
    }
    articleExistsInIssue(issue, targetArticleId) {
        return issue.articles.includes(targetArticleId);
    }

    setSessionData(updatingData: object, article_data: articleDetail) {
        if (isPlatformBrowser(this.platformId)) {
            const stringify_data = JSON.stringify(updatingData);
            sessionStorage.setItem('article_view_count', stringify_data);
            const dataParams = {
                doi: article_data.doi,
                published_date: article_data.published_date,
                journal_id: article_data.journal_id,
                journal_title: article_data.journal_title,
                volume: article_data.volume_id,
                issue: article_data.issue_id,
                article_id: article_data.article_id,
                article_title: article_data.article_title,
            };
        }

        // this.articleService
        //     .articleViewCount(dataParams)
        //     .subscribe();
    }

    //to change the highlight style of article outlines
    styleChange(position: number, secid: string) {
        if (isPlatformBrowser(this.platformId)) {
            this.clickedstatus = true;
            this.activeline = [];
            this.activeline[position] = true;
            this.activebutton = [];
            this.activebutton[position] = true;
            const secEle = document.querySelector("[id='" + secid + "']");
            const titEle = secEle?.querySelector("[class='title']");
            const text = titEle?.textContent;
            this.clickedPos = this.articleOutline.findIndex((x) => x.title == text);
            const fragment = secid;
            const currentUrl = this.location.path();

            // Navigate to the URL with the fragment
            this.router.navigateByUrl(currentUrl + '#' + fragment);
            this.scrollToElement(secEle);
            if (window.innerWidth <= 768) this.showArticleOutline();
        }
    }

    //to scroll to particular element's position
    scrollToElement(pageElement) {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                if (pageElement) {
                    window.scrollTo({
                        top: pageElement.offsetTop + 480,
                        behavior: 'smooth',
                    });
                }
            }, 500);
        }

    }

    //to convert some xml tag types to html
    structuringData(data: string, type?: string) {
        const regexMap = {
            '<em>': '<em>',
            '</em>': '</em>',
            '<strong>': '<strong>',
            '</strong>': '</strong>',
            '<bold>': '<strong>',
            '</bold>': '</strong>',
            '<addr-line': "<span class='affil'",
            '</addr-line>': '</span>',
            '<institution': "<span class='affil'",
            '</institution>': '</span>',
            '<country': "</span class='affil'",
            '</country>': '</span>',
            '<email': "<span class='affil'",
            '</email>': '</span>',
            '<i>': '<span class="italic-class">',
            '</i>': '</span>',
            '<italic>': '<span class="italic-class">',
            '</italic>': '</span>',
            '<ext-link [^>]*xlink:href=': "<a target='_blank' rel='noopener noreferrer' class='doi-underline' href=",
            "<ext-link xlink:href=": "<a target='_blank' rel='noopener noreferrer' class='doi-underline' href=",
            "</ext-link>": "</a>",
            "<div class='list'": "<ul class='list'",
            //convert footnote xref markers (e.g. in article title) to the same tooltip-ready markup used in the article body
            '<xref ref-type="fn" rid="([^"]+)"><sup>': "<sup class='xref' attr-ref-type='fn' rid='$1'>",
            '</sup></xref>': '</sup>',
            // '<p>': '<div>',
            // '</p>': '</div>',
            // '<label>': '<span>',
            // '</label>': '</span>',
        };
        // Object.entries(regexMap).forEach(([pattern, replacement]) => {

        //     data = data.replace(new RegExp(pattern, 'gmi'), replacement);
        // });
        if (typeof data === 'string') {
            Object.entries(regexMap).forEach(([pattern, replacement]) => {
                data = data.replace(new RegExp(pattern, 'gmi'), replacement);
            });
        }
        if (type === 'title') {
            data = String(data);
            data = data.replace(/‘(.*?)’/g, '“$1”');

            // Replace straight single quotes ' with straight double quotes "
            data = data.replace(/'/g, '"');

            return data;
        }
        return data;
    }

    //for getting the author details
    getAuthorlist(authors: authors_data[]) {
        this.authors = authors;
        const fullname1: string[] = [];
        const fullname2: string[] = [];
        // const icon = ['fas', 'list-ul']
        // const userIcon = '<fa-icon class="iconcls citation-icon Outline Outlineicon" aria-hidden="true" [icon]=["fas","list-ul"]> </fa-icon>'
        // const userIcon='<i aria-hidden="true" class="fa fa-user"></i>';
        if (authors) {
            authors.map((element) => {
                let detail = '';
                const spanStyle = "font-weight: bold;font-size:17px";
                detail =
                    "<span class='ref-pop-heading'><span class='tooltip-author' style='" + spanStyle + "'>" +
                    element.given_name +
                    ' ' +
                    element.surname + this.correspAuthor(element) +
                    '</span></span>';

                if (element.affiliations) {
                    detail +=
                        "<div class='pt-2 detail'><div class='authorpopup-sub-heading'>Affiliation</div><div class='aff'>";
                    element.affiliations.forEach((each) => {
                        if (each.aff)
                            detail += each.aff + '';
                    });
                    if (element.corresp) {
                        element.corresp.forEach((each) => {
                            detail +=
                                "<div class='pt-2 affil pb-2'>" +
                                each.notes +
                                '</div>';
                        });
                    }
                    detail += '</div>';
                }
                if (element.notes) {
                    element.notes.forEach(each => {
                        // const cleanedString = each.flag.replace(/<\/?sup>/g, '');
                        // const spanStyle = "vertical-align: super; font-size: smaller;";

                        each.notes = this.structuringData(each.notes, 'note');
                        detail = detail + '<span class="author-falg">' + each.flag + '</span>' + '<span class="author-notes">' + each.notes + '</span>';

                    })
                }
                if (element.credit_taxonomy) {
                    detail +=
                        "<div class='credit_taxonomy pt-2'>" +
                        "<div class='authorpopup-sub-heading'>Casrai/NISO CRediT roles</div>";
                    element.credit_taxonomy.forEach((each) => {
                        detail +=
                            "<span class='d-inline-block'><a class='affil' target='_blank' href='" +
                            each.vocab_identifier +
                            "' title='" + each.vocab_term + "'>";
                        if (each.degree_contribution) {
                            detail += each.vocab_term + ' (' + each.degree_contribution + ')';
                        } else {
                            detail += each.vocab_term;
                        }
                        detail += '</a></span>';
                    });
                    detail += '</div>';
                }
                let name = "<div class='tooltips affiliation-popover-content  p-0'>";
                let email = '';
                if (element.orcid) {
                    name +=
                        "<img  src='assets/logos/orcid_logo.png' width='20px' height='18px' alt='Open ORCID profile in a new window' role='button' tabindex='0' style='position:relative;top:-2px;padding-right:3px;cursor:pointer;' onclick=\"window.open('" +
                        element.orcid +
                        "', 'Orcid Link', 'resizeable,height=800,width=600')\">";

                    detail +=
                        "<div class='popover-orcid pt-1'><img src='assets/logos/orcid_logo.png' width='20px' height='18px' alt='Open ORCID profile in a new window' style='position:relative;top:-2px;padding-right:3px;margin-left: 0%;''><a class='affil' onclick=\"window.open('" +
                        element.orcid +
                        "', 'Orcid Link', 'resizeable,height=800,width=600')\" title='" +
                        "'>" +
                        element.orcid +
                        "</a></div>";
                }

                if (element.email) {

                    // Split the emails into an array
                    const emails = element.email.split(',').map(e => e.trim());

                    emails.forEach(em => {

                        // Small icon inline
                        email += `
                            <img src='assets/images/icons/email_icon.png'
                                width='20px'
                                height='18px'
                                alt=''
                                style='position:relative; top:-2px; padding-left:5px; width:auto;'>
                        `;

                        // Popover detail line
                        detail += `
                            <div class='popover-orcid pt-1'>
                                <p class='mb-0'>
                                    <img src='assets/images/icons/email_icon.png'
                                        width='17px'
                                        alt=''
                                        style='position:relative; top:-2px;'>
                                    ${em}
                                </p>
                            </div>
                        `;
                    });
                }

                name += "<span style='font-weight:600;'>";
                if (element?.specific_use == 'icwau') {
                    name += 'in conversation with ';
                } else if (element?.specific_use == 'wffau') {
                    name += 'with a Foreword from ';
                }
                name +=
                    element.given_name +
                    ' ' +
                    element.surname + this.correspAuthor(element) +
                    "</span>" +
                    email +
                    "<span class='tooltiptext'>" +
                    detail +
                    '</span></div></div>';
                fullname1.push(name);

                const sname = element.given_name + ' ' + element.surname;
                fullname2.push(sname);
            });
        }
        return fullname1.join(', ');
    }

    correspAuthor(articles) {
        let span = '';
        if (articles.corresp_author == 'yes') {
            const spanStyle = "vertical-align: super; font-size: smaller;";
            span = `<span style="${spanStyle}">*</span>`;
        }
        if (articles.notes) {
            articles.notes.forEach(each => {
                const cleanedString = each.flag.replace(/<\/?sup>/g, '');
                const spanStyle = "vertical-align: super; font-size: smaller;";
                span = span + `<span style="${spanStyle}">${cleanedString}</span>`;
            });
        }
        return span;
    }

    //for setting the cite article
    setCiteArticle(articlelist) {

        // if (this.authors?.length > 2) {
        //     latin_etc = "<span style='font-style:italic;'> et al</span>. ";
        // }

        let author_data;

        if (this.articlelist.citation_author != null) {
            author_data = this.articlelist.citation_author ? this.articlelist.citation_author : this.articlelist.left_running_head

        } else {
            let latin_etc = '';
            const authors: string[] = [];

            if (this.authors?.length > 1) {
                latin_etc = " with ";
            }

            if (this.authors) {
                for (let i = 0; i < 1; i++) {
                    authors.push(this.authors[i]?.surname);
                }
                author_data = authors.join(', ') + latin_etc;
                for (let i = 1; i < this.authors?.length; i++) {
                    author_data = author_data + this.authors[i]?.surname
                    if (i != this.authors?.length - 1) {
                        author_data += ', ';
                    }
                }
            }
        }

        this.cite =
            author_data + ' (' + articlelist.copyright_year + ')' +
            ", ‘" +
            this.structuringData(articlelist.right_running_head, 'title') +
            "’, <span style='font-style:italic;'>" +
            articlelist.journal_title +
            '</span>, ' +
            articlelist.volume_id + this.changeIssueForCite(articlelist.issue_id) + ': ' + articlelist.article_id +
            " <a target='_blank' class='doi-underline' href='https://doi.org/" +
            articlelist.doi +
            "' title='https://doi.org/" + articlelist.doi + "'>https://doi.org/" + articlelist.doi + '</a>';
        return this.cite;
    }

    //for restructuring the html of article
    restructureArticleHtml(articleHtml: string) {
        
        this.articleOutline = [];
        // const html = this.parser.parseFromString(articleHtml, 'text/html');
        if (this.parser) {
            const html = this.parser.parseFromString(articleHtml, 'text/html');
            // Continue processing html...            

            const content = html.querySelector("[class='front']");
            content?.classList.add('display');
            //Restructuring tables
            const tables = html.querySelectorAll("[class='table-wrap']");
            tables.forEach((table) => {
                table.setAttribute('class', 'article-table-wrap');
                const tbl = table.querySelector('table');
                tbl?.classList.add('table-bordered');
                tbl?.classList.add('mt-2');
                const altTextElements = table.getElementsByClassName('alt-text');
                Array.from(altTextElements).forEach((altTextElement) => {
                    altTextElement.classList.add('hidden');
                });
            });

            const bodyTag = html.querySelector('.body');
            if (bodyTag?.innerHTML.trim() === '') {
                this.pdf_body_button = true;
            }

            //to set superior numbers
            const sup_tag = html.querySelectorAll("[class='sup']");
            sup_tag.forEach((sup_each) => {
                sup_each.setAttribute('style', 'vertical-align: super; font-size: smaller;font-style:normal;');
            });
            //to hide fn-group
            const fn_group = html.querySelector("[class='fn-group']");
            if (fn_group) {
                fn_group.setAttribute('style', 'display: none;');
            }
            //open external http/https links safely in a new tab
            this.secureExternalLinks(html);
            //to show bullet
            const bullet_tag = html.querySelectorAll("[attr-list-type='bullet']");
            bullet_tag.forEach(each_bullet => {
                if (isPlatformBrowser(this.platformId)) {
                    const ul = document.createElement('ul');
                    ul.setAttribute('id', each_bullet.id);
                    ul.setAttribute('attr-list-type', 'bullet');
                    ul.className = 'list';

                    // Find all list-item divs and convert them to <li>
                    const listItems = each_bullet.querySelectorAll('.list-item');
                    listItems.forEach(listItem => {
                        const li = document.createElement('li');
                        li.className = 'list-item';

                        // Move the content from the list-item to the <li>
                        while (listItem.firstChild) {
                            li.appendChild(listItem.firstChild);
                        }

                        ul.appendChild(li);
                    });

                    // Replace the old list div with the new <ul>
                    each_bullet.replaceWith(ul);
                }
            });

            //for setting the article outline headings
            let childSec = false;
            let parentSec = false;
            let ack = false;
            const secElements = html.querySelectorAll("[class='sec']");
            secElements.forEach((secEle) => {
                childSec = secEle.querySelectorAll("[class='sec']") != null;
                parentSec = secEle.parentElement?.className != 'sec';
                ack = secEle.parentElement?.className != 'back';
                if (childSec && parentSec) {
                    const title = secEle.querySelector("[class='title']");

                    title?.classList.add('title-wrap');
                    const label = secEle.querySelector("[class='label']");
                    label?.classList.add('sec-label');
                    const titleText = title?.textContent ? title?.textContent : '';
                    const secid = secEle?.getAttribute('id') as string;
                    const outline: articleOutline = { outlineId: '', title: '' };
                    outline.outlineId = secid;
                    outline.title = titleText;
                    if (ack) {
                        this.articleOutline.push(outline);
                    }
                } else {
                    if (childSec) {
                        const title: Element | null =
                            secEle.querySelector("[class='title']");
                        title?.classList.add('sub');
                    }
                }
            });
            const ackElement = html.querySelector("[class='ack']");
            if (ackElement) {
                const title: Element | null = ackElement.querySelector("[class='title']");
                const titleText = title?.textContent ? title?.textContent : '';
                ackElement.setAttribute('id', 'ack12');
                const outline: articleOutline = { outlineId: '', title: '' };
                outline.outlineId = 'ack12';
                outline.title = titleText;
                this.articleOutline.push(outline);
            }

            //to get appendix
            const appendix = html.querySelectorAll(".back> .app-group > .app");
            appendix?.forEach(elem => {
                const title: Element | null = elem.querySelector(".label");
                title?.classList.add('title-wrap');
                title?.classList.add('title');
                const titleText = title?.textContent ? title?.textContent : '';
                const appid = elem?.getAttribute('id') as string;
                const outline: articleOutline = { outlineId: '', title: '' };
                outline.outlineId = appid;
                outline.title = titleText;
                this.articleOutline.push(outline);
            });
            const refElement: HTMLElement = html.querySelector("[class='ref-list']") as HTMLElement;
            if (refElement) {
                const title: Element | null = refElement.querySelector("[class='title']");
                const allRefElements = refElement.querySelectorAll("[class='ref']");
                allRefElements.forEach((allRefElementsTag: Element) => {
                    this.setSeeArticleLink(allRefElementsTag)
                });
                // this.referenceData = refElement;
                const titleText = title?.textContent ? title?.textContent : '';
                refElement.setAttribute('id', 'ref12');
                const outline: articleOutline = { outlineId: '', title: '' };
                outline.outlineId = 'ref12';
                outline.title = titleText;
                const refItems =
                    refElement.querySelectorAll("[class='ref']");
                refItems.forEach(element => {
                    const anchorTag = element.querySelector('a');
                    const regex = new RegExp('doi|DOI', 'gi');
                    const data = anchorTag?.getAttribute('href')?.match(regex);
                    if (data) {
                        if (isPlatformBrowser(this.platformId)) {
                            const innerContent = anchorTag?.getAttribute('href');
                            const modifiedUrl = innerContent?.replace(/^https:\/\/doi\.org\//, '');
                            const divElement = this.renderer.createElement('div');
                            divElement.className = 'scite-badge pt-1 ml-0';
                            divElement.setAttribute('data-doi', modifiedUrl);

                            divElement.setAttribute('data-show-zero', 'true');
                            // if (window.innerWidth <= 370) {
                            //     divElement.setAttribute('data-small', 'true');
                            //     divElement.setAttribute('data-layout', 'vertical');
                            //     divElement.setAttribute('data-show-labels', 'true');
                            // }
                            // else {
                            divElement.setAttribute('data-small', 'false');
                            divElement.setAttribute('data-layout', 'horizontal');
                            divElement.setAttribute('data-show-labels', 'false');
                            // }
                            // divElement.setAttribute('data-show-labels', 'false');
                            divElement.setAttribute('data-tally-show', 'true');
                            divElement.setAttribute('style', 'margin-left: 2px;');
                            // element.childNodes[1].appendChild(divElement);
                            element.appendChild(divElement);
                        }
                    }
                });
                this.articleOutline.push(outline);

            }
            //Restructuring image element
            const imgcontent = html.getElementsByClassName('fig')
            // const imgElement = html.querySelectorAll('img');
            this.imagePaths = []
            this.clipPaths = []
            Array.from(imgcontent).forEach((dataElement: any) => {
                const img = dataElement.querySelector('img') as HTMLElement
                const altTextElements = dataElement?.getElementsByClassName('alt-text');
                let altTextValue = '';
                if (altTextElements && altTextElements.length > 0) {
                    const altTextElement = altTextElements[0] as HTMLElement;
                    altTextValue = altTextElement.innerText;
                    altTextElement.classList.add('hidden');
                    // img.setAttribute('alt', altTextValue);
                }
                // img.setAttribute('alt', 'graphic image');
                img.setAttribute('width', '100%');
                img.setAttribute('height', '100%');
                img.setAttribute('alt', altTextValue);
                const clipFile = dataElement?.getAttribute('attr-fig-type') as string
                if (clipFile) {
                    const srcValue = img?.getAttribute('href') as string;
                    img.setAttribute(
                        'src',
                        this.env.articleImage +
                        this.articlelist.art_file_path +
                        '/' +
                        srcValue
                    );
                    const data: imagePaths = {
                        srcValue: srcValue,
                        imageUrl:
                            this.env.articleImage +
                            this.articlelist.art_file_path + '/' + srcValue,
                    };
                    this.clipPaths.push(data);
                }
                else {

                    const srcValue = img?.getAttribute('href') as string;
                    img.setAttribute(
                        'src',
                        this.env.articleImage +
                        this.articlelist.art_file_path +
                        '/' +
                        srcValue
                    );
                    const data: imagePaths = {
                        srcValue: srcValue,
                        imageUrl:
                            this.env.articleImage +
                            this.articlelist.art_file_path + '/' + srcValue,
                    };


                    this.imagePaths.push(data);

                }

            });
            const newImgcontent = html.getElementsByClassName('inline-graphic')
            Array.from(newImgcontent).forEach((dataElement) => {
                const img = dataElement.querySelector('img') as HTMLElement
                dataElement.setAttribute('alt', 'graphic image');
                const clipFile = dataElement?.getAttribute('attr-fig-type') as string
                if (clipFile) {
                    const srcValue = dataElement?.getAttribute('href') as string;
                    dataElement.setAttribute(
                        'src',
                        this.env.articleImage +
                        this.articlelist.art_file_path +
                        '/' +
                        srcValue
                    );
                    dataElement.setAttribute(
                        'id',
                        srcValue
                    );
                    const data: imagePaths = {
                        srcValue: srcValue,
                        imageUrl:
                            this.env.articleImage +
                            this.articlelist.art_file_path + '/' + srcValue,
                    };
                    this.clipPaths.push(data);
                }
                else {
                    const srcValue = dataElement?.getAttribute('href') as string;
                    dataElement.setAttribute(
                        'src',
                        this.env.articleImage +
                        this.articlelist.art_file_path +
                        '/' +
                        srcValue
                    );
                    dataElement.setAttribute(
                        'id',
                        srcValue
                    );
                    const data: imagePaths = {
                        srcValue: srcValue,
                        imageUrl:
                            this.env.articleImage +
                            this.articlelist.art_file_path + '/' + srcValue,
                    };

                    this.imagePaths.push(data);
                }
            });

            //for setting graphic classes
            const graphicImages = html.querySelectorAll("[class='graphic']");
            graphicImages?.forEach(elem => {
                if (elem.getAttribute('src') == null) {
                    elem.setAttribute('alt', 'graphic image');
                    const clipFile = elem?.getAttribute('attr-fig-type') as string
                    if (clipFile) {
                        const srcValue = elem?.getAttribute('href') as string;
                        elem.setAttribute(
                            'src',
                            this.env.articleImage +
                            this.articlelist.art_file_path +
                            '/' +
                            srcValue
                        );
                        elem.setAttribute(
                            'id',
                            srcValue.slice(0, -4)
                        );
                        if (elem.parentElement?.className != 'td') {

                            const data: imagePaths = {
                                srcValue: srcValue,
                                imageUrl:
                                    this.env.articleImage +
                                    this.articlelist.art_file_path + '/' + srcValue,
                            };
                            this.clipPaths.push(data);
                        }
                    }
                    else {
                        const srcValue = elem?.getAttribute('href') as string;

                        elem.setAttribute(
                            'src',
                            this.env.articleImage +
                            this.articlelist.art_file_path +
                            '/' +
                            srcValue
                        );
                        elem.setAttribute(
                            'id',
                            srcValue.slice(0, -4)
                        );
                        if (elem.parentElement?.className != 'td') {
                            const data: imagePaths = {
                                srcValue: srcValue,
                                imageUrl:
                                    this.env.articleImage +
                                    this.articlelist.art_file_path + '/' + srcValue,
                            };
                            this.imagePaths.push(data);

                        }
                    }
                }

            })

            //for setting href in reference a tag elements
            const images = html.querySelectorAll("[class='article-table-wrap']");
            this.tableOverview = [];
            images.forEach((element) => {
                const data: tableOverview = {
                    tableCount: element.childNodes[0].textContent,
                    tableTitle: element.childNodes[1].textContent,
                    tableId: element.id,
                };
                this.tableOverview.push(data);
            });
            this.initCarousel();
            const serializer = new XMLSerializer();
            this.articleHtml = serializer.serializeToString(html);
            this.loadWidgets();
            if (this.articleOutline.length == 0) {
                const divele = this.articleContent?.nativeElement;
                if (divele) {
                    divele.classList.remove('article-contents')

                    divele.classList.add('article-new-contents')
                }
            }

            setTimeout(() => {
                if (isPlatformBrowser(this.platformId)) {
                    const data = document.getElementsByClassName('WaJfckMfIXKpjzwS10jA')
                    Array.from(data).forEach((eachElement) => {
                        eachElement.remove()

                    })
                }
            }, 5000);
            this.scrollToPreviousSection();
        } else {
            this.articleHtml = articleHtml;
        }
    }

    setSeeArticleLink(allRefElementsTag) {
        if (isPlatformBrowser(this.platformId)) {
            // console.log(allRefElementsTag);
            // let id = allRefElementsTag.getAttribute('id')
            // if (id.includes('r')) {
            //     var identifier = allRefElementsTag.id;
            //     var numericPart = identifier.substring(1); // Extract the numeric part of the ID
            //     var newID = "fn" + numericPart; // Construct the new ID
            //     allRefElementsTag.id = newID; // Change the ID of the element
            // }
            const title = allRefElementsTag.querySelector("[class='article-title']")
            const link = allRefElementsTag.querySelector("[class='ext-link ']");
            // const referenceLinkbrcontent = document.createElement("br");
            // allRefElementsTag.appendChild(referenceLinkbrcontent);
            const googleScholarLink = document.createElement("a");
            const googleScholarhref = allRefElementsTag.innerText
            googleScholarLink.href = "https://scholar.google.com/scholar?q=" + googleScholarhref;
            googleScholarLink.title = "https://scholar.google.com/scholar?q=" + googleScholarhref;
            googleScholarLink.textContent = "Google Scholar";
            googleScholarLink.target = "_blank"; // Open in a new tab
            googleScholarLink.className = 'seen-article seen-article-scholar '; // Open in a new tab
            allRefElementsTag.appendChild(googleScholarLink);
            if ((title || link)) {
                const href = link?.getAttribute('href');

                if (link) {
                    const newElement = this.renderer.createElement('a');

                    if (title) {
                        this.renderer.setAttribute(newElement, 'class', 'article-title');
                        this.renderer.setAttribute(newElement, 'href', href || '#');
                        this.renderer.setAttribute(newElement, 'target', '_blank');
                        this.renderer.insertBefore(title.parentElement, newElement, title);
                        this.renderer.removeChild(title.parentElement, title);
                    }

                    link.setAttribute('target', '_blank');
                } else if (title) {
                    const newElement = this.renderer.createElement('span');
                    this.renderer.setAttribute(newElement, 'class', 'article-title');
                    this.renderer.insertBefore(title.parentElement, newElement, title);
                    this.renderer.removeChild(title.parentElement, title);
                }
            }
            if (link) {
                const str = link.innerText;
                const substr = 'doi';
                if (str.includes(substr)) {
                    const hrefattribute = link?.getAttribute('href')
                    const referenceLinkhref = document.createElement("a");
                    referenceLinkhref.className = 'seen-article-article';
                    referenceLinkhref.textContent = "Crossref";
                    this.renderer.setAttribute(referenceLinkhref, 'href', hrefattribute);
                    this.renderer.setAttribute(referenceLinkhref, 'title', hrefattribute);
                    this.renderer.setAttribute(referenceLinkhref, 'target', '_blank');
                    allRefElementsTag.appendChild(referenceLinkhref);
                }
            }

            // const referenceLink = document.createElement("span");
            // referenceLink.className = 'seen-article-article';
            // referenceLink.textContent = "Seen Article";
            // this.renderer.setAttribute(referenceLink, 'refid', allRefElementsTag.id);
            // allRefElementsTag.appendChild(referenceLink);
            const referenceLinkbr = document.createElement("br");
            allRefElementsTag.appendChild(referenceLinkbr);
        }
    }

    // scrollToTopfn() {

    //     // this.contentLoaded.nativeElement.scrollIntoView({
    //     //     block: 'center',
    //     // });
    //     //     const element = this.contentLoaded.nativeElement as HTMLElement;
    //     // const viewportHeight = window.innerHeight;
    //     // const elementHeight = element.offsetHeight;
    //     // const offsetTop = element.offsetTop;

    //     // // Calculate the target scroll position to center the element
    //     // const scrollTop = offsetTop - (viewportHeight / 2) + (elementHeight / 2);
    //     //     window.scrollTo({
    //     //         top: scrollTop,
    //     //         behavior: 'smooth' // Use smooth scrolling if supported
    //     //       });
    //     const element = this.contentLoaded.nativeElement as HTMLElement;
    //     // Scroll to the top of the element
    //     element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }
    scrollToTopfn() {
        const element = this.contentLoaded.nativeElement as HTMLElement;
        // Check if element exists and is part of the DOM
        if (element) {
            // Use scrollIntoView to scroll to the top of the element smoothly
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        if (isPlatformBrowser(this.platformId)) {
            const visible = false;
            const scrollPosition =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                0;
            // let threshold =1000; // The scroll position at which to make the element fixed
            clearTimeout(this.scrollEndTimeout);
            if (this.clickedstatus == false) {
                for (let i = 0; i < this.articleOutline.length; i++) {
                    const targetSec: HTMLElement | null = document.querySelector(
                        "[id='" + this.articleOutline[i].outlineId + "']"
                    );
                    if (targetSec) {
                        if (targetSec.offsetTop <= scrollPosition - 450) {
                            const eleId = targetSec?.getAttribute('id');
                            const ind = this.articleOutline.findIndex(
                                (x) => eleId == x.outlineId
                            );
                            this.activeline = [];
                            this.activeline[ind] = true;
                            this.activebutton = [];
                            this.activebutton[ind] = true;
                            const chapterEle: Element | null =
                                document.querySelector(
                                    "[id='" + this.articleOutline[ind].outlineId + "']"
                                );
                            if (chapterEle) {
                                const container = this.articleHead.nativeElement;
                                container.scrollTop = chapterEle['offsetTop'] - 200;
                            }
                        } else {
                            break;
                        }
                    }
                }
            }
            const scrollpos = 100;
            let threshold = this.basicInfoDiv?.nativeElement.offsetHeight;
            if (this.keywordDiv) {
                if (this.keywordDiv.nativeElement?.offsetHeight != undefined)
                    threshold = this.basicInfoDiv?.nativeElement.offsetHeight + this.keywordDiv?.nativeElement.offsetHeight + 100;
            }
            if (scrollPosition >= threshold && scrollPosition <= this.articleContent?.nativeElement.offsetHeight) {
                this.scrollingTitleSection?.nativeElement.classList.remove('d-none');
                if (document.getElementById('header'))
                    this.headerHeight = document.getElementById('header')?.offsetHeight as number;

                const tooltips = this.scrollingTitleSection.nativeElement.querySelectorAll('.tooltiptext');
                tooltips.forEach(e => {
                    this.expanded ? e.setAttribute('style', 'position: fixed !important; top:' + (this.scrollingTitleSection.nativeElement.offsetHeight + window.innerWidth < 612 ? 70 : 80) + 'px!important;left:31% !important; font-size:12px !important;') :
                        e.setAttribute('style', 'position: fixed !important; top:' + (this.scrollingTitleSection.nativeElement.offsetHeight + 80) + 'px!important;left:' + this.getLeftValue() + ' !important; font-size:12px !important;')
                })
                const tooltipHeding = this.scrollingTitleSection.nativeElement.querySelectorAll('.affiliation-popover-content');
                tooltipHeding.forEach(e => {
                    e.children[0].setAttribute("style", 'padding-right: 2px;margin-bottom: 3px;');
                    window.innerWidth > 425 ? e.children[1]?.setAttribute('style', 'font-size:16px') : e.children[1]?.setAttribute('style', 'font-size:12px');
                    e.children[2]?.children[0]?.setAttribute("style", ' padding-top: 4px;    margin-bottom: 4px;');
                    e.classList.remove('pt-2');
                })
                const articleOutlineElement = this.articleOutlin?.nativeElement;

                if (visible == false) {
                    this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'width', this.htmlContent?.nativeElement.offsetWidth + 'px');
                    if (window.innerWidth >= 768) {
                        // Articles with no outline/TOC (e.g. Conversation-type articles) never render
                        // #articleOutlin, so guard against it being undefined here.
                        if (articleOutlineElement) {
                            this.renderer.setStyle(articleOutlineElement, 'position', 'fixed');
                            this.renderer.setStyle(articleOutlineElement, 'top', (this.headerHeight + 20) + 'px');
                            this.renderer.setStyle(articleOutlineElement, 'height', '100vh !important');
                            // this.renderer.setStyle(this.articleOutlin.nativeElement, 'width', '20%');
                            this.renderer.setStyle(articleOutlineElement, 'width',
                                (this.articleOutlinecol.nativeElement.offsetWidth) + 'px');
                            // this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'left', this.articleOutlinecol?.nativeElement.offsetWidth + 90 + 'px');
                        }
                    }
                    else {
                        this.audiobuttons?.nativeElement.classList.add('audio-button');

                        // this.headingSectionDivLeft = window.innerWidth <= 600 ?30  : this.articleOutlinecol.nativeElement.offsetWidth+90;
                    }
                    const bottomDiv = document.getElementById('bottom-div') as HTMLElement; // Adjust with your bottom div ID
                    const bottomDivRect = bottomDiv.getBoundingClientRect();
                    if ((bottomDivRect.top - 40) <= window.innerHeight) {
                        this.audiobuttons?.nativeElement.classList.remove('audio-button');
                    }
                }
            } else {
                if (scrollPosition < threshold && this.toggleOutline) {
                    this.renderer.setStyle(this.articleOutlin.nativeElement, 'top', (this.headerHeight + 13) + 'px');
                }
                if (scrollPosition < threshold && window.innerWidth > 768) {
                    this.toggleOutline = false;
                    // this.articleOutlin?.nativeElement.removeSty('style');
                }
                this.scrollingTitleSection?.nativeElement.classList.add('d-none');
                if (this.articleOutlin?.nativeElement) {
                    this.audiobuttons?.nativeElement.classList.remove('audio-button');
                    // if (!this.toggleOutline) {
                    this.renderer.removeStyle(this.articleOutlin?.nativeElement, 'position');
                    // this.renderer.removeStyle(this.articleOutlin?.nativeElement, 'width');
                    this.renderer.removeStyle(this.articleOutlin?.nativeElement, 'top');
                    // }
                }

            }
            //to show or hide scrolltotop button
            if (scrollPosition >= scrollpos) {
                if (this.scrollToTop != undefined) this.scrollToTop.nativeElement?.classList.remove('display');
            } else {
                if (this.scrollToTop != undefined) this.scrollToTop.nativeElement?.classList.add('display');
            }
            if (!this.isScrolling) {
                // Scroll start logic
                this.isScrolling = true;
            }
            this.scrollEndTimeout = setTimeout(() => {
                // Scroll end logic
                this.isScrolling = false;
                if (this.clickedstatus === true) this.clickedstatus = false;
            }, 200);

            const bottomDiv = document.getElementById('bottom-div') as HTMLElement; // Adjust with your bottom div ID
            const bottomDivRect = bottomDiv.getBoundingClientRect();
            const windowHeight = window.innerHeight
            const divHeight1 = this.listContent1?.nativeElement.clientHeight
            const divHeight2 = this.listContent2?.nativeElement.clientHeight
            const divHeight3 = this.listContent3?.nativeElement.clientHeight
            let outerHeight = 0;

            if ((bottomDivRect.top - 40) <= window.innerHeight) {
                // this.articleViewBox.nativeElement.style.position = 'relative';
                if (window.innerWidth >= 768) this.articleViewBox.nativeElement.style.top = '0px';
                else this.articleViewBox.nativeElement.style.top = '0px'
                this.articleViewBox.nativeElement.style.width = '23%!important';

                if (scrollPosition <= this.articleContent?.nativeElement.offsetHeight) {
                    this.articleViewBox.nativeElement.style.position = 'relative';
                }
                else {
                    this.articleViewBox.nativeElement.style.position = 'relative';

                }
                this.articleViewBox.nativeElement.style.height = '100%';
                // this.articleViewBox.nativeElement.style.marginRight = '0rem'
                this.articleViewBox.nativeElement.style.bottom = '100%';
            } else {
                if (window.scrollY > 50) {
                    if (scrollPosition <= this.articleContent?.nativeElement.offsetHeight && window.innerWidth >= 992) {
                        this.articleViewBox.nativeElement.style.position = 'fixed';
                        this.articleViewBox.nativeElement.style.top = '95px';

                    }
                    else {
                        this.articleViewBox.nativeElement.style.position = 'relative';
                    }
                    if (divHeight2) {
                        outerHeight = divHeight1 + divHeight2 + divHeight3
                    }
                    else
                        outerHeight = divHeight1 + divHeight3
                    const pageOutlineHeight = windowHeight - outerHeight - 150
                    if (this.myTabContent)
                        this.myTabContent.nativeElement.style.height = pageOutlineHeight + 'px';
                }
                else {
                    this.articleViewBox.nativeElement.style.position = 'relative';
                    this.articleViewBox.nativeElement.style.top = '0px'
                    if (divHeight2) {
                        outerHeight = divHeight1 + divHeight2 + divHeight3
                    }
                    else
                        outerHeight = divHeight1 + divHeight3
                    const pageOutlineHeight = windowHeight - outerHeight - 150
                    if (this.myTabContent)
                        this.myTabContent.nativeElement.style.height = pageOutlineHeight + 'px';
                }
                if (this.articleViewBox)
                    this.articleViewBox.nativeElement.style.height = '100%';
            }
            this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'width', (this.htmlContent?.nativeElement.offsetWidth + 15) + 'px');
            this.headingSectionDivLeft = window.innerWidth <= 612 ? 30 : (this.articleOutlinecol?.nativeElement.offsetWidth ?? 0) + 70;
            // const bottomDivContent = document.getElementById('articleViewContents') as HTMLElement; // Adjust with your bottom div ID
            // const bottomDivRectContent = bottomDivContent.getBoundingClientRect();
            // if (bottomDivRectContent.top <= window.innerHeight) {
            //     // If the bottom div starts displaying, remove fixed position
            //     this.articleOutlin.nativeElement.style.position = 'absolute';
            //     this.articleOutlin.nativeElement.style.width = '17%';
            // }
            // else {
            //     this.articleOutlin.nativeElement.style.position = 'fixed';
            //     this.articleOutlin.nativeElement.style.width = '17%';

            // }
        }
    }
    @HostListener('window:resize', ['$event'])
    onResize() {
        if (isPlatformBrowser(this.platformId)) {
            // Handle window resize event here
            // if(window.innerWidth<=1024){
            //     this.expanded=true;
            // }
            // else this.expanded=false;
            const windowHeight = window.innerHeight
            const divHeight1 = this.listContent1.nativeElement.clientHeight
            const divHeight2 = this.listContent2?.nativeElement.clientHeight
            const divHeight3 = this.listContent3.nativeElement.clientHeight
            let outerHeight = 0;
            if (divHeight2) {
                outerHeight = divHeight1 + divHeight2 + divHeight3
            }
            else
                outerHeight = divHeight1 + divHeight3
            const pageOutlineHeight = windowHeight - outerHeight - 150
            this.myTabContent.nativeElement.style.height = pageOutlineHeight + 'px';
            const firstChild = this.myTabContent?.nativeElement.children[0] as HTMLElement;

            if (firstChild) {
                if (window.innerWidth > 1800) {
                    // firstChild.style.width = '';
                    // firstChild.style.overflowX = '';
                } else {
                    firstChild.style.width = '100%!important';
                    // firstChild.style.overflowX = 'scroll';
                    // firstChild.style.setProperty('scrollbar-width', 'thin');
                }
            }


            // if (this.smallDeviceOutLine)
            //     this.renderer.setStyle(this.smallDeviceOutLine?.nativeElement, 'left', '3rem');
            // if (this.articleOutlin)
            //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'left', '72px');

            this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'top', this.headerHeight + 20 + 'px !important');
            const tooltips = this.scrollingTitleSection?.nativeElement.querySelectorAll('.tooltiptext');
            tooltips.forEach(e => {
                this.expanded ? e.setAttribute('style', 'position: fixed !important; top:' +
                    (this.scrollingTitleSection?.nativeElement.offsetHeight + 80) +
                    'px!important;left:31% !important; font-size:12px !important;') :
                    e.setAttribute('style', 'position: fixed !important; top:' +
                        (this.scrollingTitleSection?.nativeElement.offsetHeight + 80) + 'px!important;left:' + this.getLeftValue() +
                        ' !important; font-size:12px !important;')
            })
            this.renderer.setStyle(this.articleOutlin?.nativeElement, 'width',
                (this.articleOutlinecol.nativeElement.offsetWidth) + 'px');
            this.aricleContentAreaWidth = this.aricleContentArea?.nativeElement.offsetWidth;
            if (window.innerWidth <= 612) {
                this.aricleContentAreaWidth = this.aricleContentArea?.nativeElement.offsetWidth - 55;
            }

            this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'width', (this.htmlContent?.nativeElement.offsetWidth + 15) + 'px');
            this.headingSectionDivLeft = window.innerWidth <= 612 ? 30 : (this.articleOutlinecol?.nativeElement.offsetWidth ?? 0) + 70;

        }

    }
    getLeftValue(): string {
        const outlineWidth = this.articleOutlin?.nativeElement.offsetWidth;
        if (!outlineWidth) {
            return '27%'
        }
        else {
            return outlineWidth + 100 + 'px';
        }
    }

    // copyToClipboard() {
    //     // Get the contents of the div
    //     const divContents = this.citation.nativeElement.innerText;
    //     // Copy the contents to the clipboard
    //     navigator.clipboard.writeText(divContents);
    // }
    copyToClipboard() {
        // Get the contents of the div
        const divContents = this.citation.nativeElement.innerText;

        // Copy the contents to the clipboard
        navigator.clipboard.writeText(divContents).then(() => {
            // Set a flag to show the message
            this.isCopied = true;

            // Reset the flag after a delay (e.g., 2 seconds) to hide the message
            setTimeout(() => {
                this.isCopied = false;
                this.citeModal = false;
            }, 2000);
        });
    }

    // getArticleImageUrl(oneArticle: articleDetail) {
    //     let url = '';
    //     url =
    //         oneArticle.volume_id + '/' + oneArticle.issue_id + '/' + oneArticle.article_id + '/' + oneArticle.article_cover_image;
    //     return url;
    // }

    ngOnDestroy() {
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });

        this.destroyMetaTagsforSEONew();
        this.subscription.unsubscribe();
    }

    //to display modal and to navigate to reference
    refClick(event: Event) {
        if (isPlatformBrowser(this.platformId)) {
            this.imageModal = false;
            this.citeModal = false;
            this.modalHrefContent = ''
            this.modalcurrentSrc = ''
            this.modalContent = ''
            const aTagEle = (event.target as HTMLInputElement);
            const refAttrVal = aTagEle?.getAttribute("attr-ref-type") as string;
            //navigate to reference
            if (aTagEle.localName == 'a' && refAttrVal == 'bibr') {
                const rid = aTagEle?.getAttribute('rid') as string;
                const referenceEle: Element | null = document.querySelector(
                    "[class='ref'][id='" + rid + "']"
                );
                referenceEle?.classList.add("blinking")
                setTimeout(() => {
                    // Code to be executed after a delay
                    referenceEle?.classList.remove("blinking")
                }, 2500);
                this.scrollToElement(referenceEle);
            }
            if (aTagEle.localName == 'p' && refAttrVal == 'bibr') {
                const rid = aTagEle?.getAttribute('rid') as string;
                const referenceEle: Element | null = document.querySelector(
                    "[class='ref'][id='" + rid + "']"
                );
                referenceEle?.classList.add("blinking")
                setTimeout(() => {
                    // Code to be executed after a delay
                    referenceEle?.classList.remove("blinking")
                }, 2500);
                this.scrollToElement(referenceEle);
            }
            //to display figure in modal
            if (aTagEle.className == 'xref' && refAttrVal == 'fig') {

                const rid = aTagEle?.getAttribute('rid') as string;
                const figEle = document.querySelector(
                    "[class='fig'][id='" + rid + "']"
                );
                if (figEle) {
                    this.heading = figEle.children[0].textContent as string;
                    this.caption = figEle.children[1].textContent as string;
                    let bodyText = '';
                    for (let i = 2; i < figEle.children.length; i++) {
                        bodyText = bodyText + figEle.children[i].outerHTML;
                    }
                    this.body = bodyText;
                }
                this.triggerModal(this.modalData);
            }
            if (aTagEle.classList.value == 'graphic carousel-images') {
                const target = event.target as HTMLElement;
                const figGroup = target?.closest('.fig-group[attr-specific-use="carousel"]');

                if (figGroup) {
                    const href = target.getAttribute('href') as string;
                    if (href) {
                        const figEle = figGroup.children[0];
                        if (figEle) {
                            this.heading = figEle.children[3].textContent as string;
                            this.caption = figEle.children[4].textContent as string;

                            let bodyText = '';
                            bodyText = figEle.children[0].outerHTML;
                            this.body = bodyText;

                        }

                        this.triggerModal(this.modalData);
                    }
                }
                else {
                    const href: string = (event.target as HTMLAnchorElement)?.getAttribute('href') as string;
                    const result = href.substring(0, href.indexOf('.')); // Get the content before the first period
                    const figEle = document.querySelector(
                        "[class='fig'][id='" + result + "']"
                    );
                    if (figEle) {
                        this.heading = figEle.children[0].textContent as string;
                        this.caption = figEle.children[1].textContent as string;
                        let bodyText = '';
                        for (let i = 2; i < figEle.children.length; i++) {
                            bodyText = bodyText + figEle.children[i].outerHTML;
                        }
                        this.body = bodyText;
                    }
                    this.triggerModal(this.modalData);
                    // const tagEle: any = event.target as HTMLElement;
                    // this.imageModal = true;
                    // this.citeModal = false;
                    // const data: any = event;
                    // this.triggerModal(this.modalData);
                    // this.modalHrefContent = data.path[1].childNodes[0].innerText;
                    // this.modalContent = data.path[1].childNodes[1].innerText;
                    // this.modalcurrentSrc = tagEle.currentSrc;
                }

            }
            //to display table in modal
            if (aTagEle.className == 'xref' && refAttrVal == 'table') {
                const rid = aTagEle?.getAttribute('rid') as string;
                const tableEle = document.querySelector(
                    "[class='article-table-wrap'][id='" + rid + "']"
                );
                if (tableEle) {
                    this.heading = tableEle.children[0].textContent as string;
                    this.caption = tableEle.children[1].textContent as string;
                    let bodyText = '';
                    for (let i = 2; i < tableEle.children.length; i++) {
                        bodyText = bodyText + tableEle.children[i].outerHTML;
                    }
                    this.body = bodyText;
                }
                this.triggerModal(this.modalData);
            }
            //navigate to the corresponding supplementary file in the Supplementary Files section
            if (aTagEle.className == 'xref' && refAttrVal == 'supplementary-material') {
                event.preventDefault();
                const rid = aTagEle?.getAttribute('rid') as string;
                const fileEle = document.querySelector(
                    "#supplementary-files [class~='supplementary_files-hover'][data-rid='" + rid + "']"
                ) as HTMLElement | null;
                if (fileEle) {
                    fileEle.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    fileEle.classList.add('supplementary-highlight');
                    setTimeout(() => {
                        fileEle.classList.remove('supplementary-highlight');
                    }, 2500);
                }
            }
            if (aTagEle.className == 'seen-article' || aTagEle.className == 'sup') {
                let rid = ''
                if (aTagEle.className == 'sup') {
                    const parentElement = aTagEle.parentElement;
                    rid = parentElement?.getAttribute('rid') as string;
                    const referenceEle: Element | null = this.articleContent.nativeElement.querySelector(
                        "[class='ref'][id='" + rid + "']"
                    );
                    referenceEle?.classList.add("blinking")
                    setTimeout(() => {
                        // Code to be executed after a delay
                        referenceEle?.classList.remove("blinking")
                    }, 2500);

                    this.scrollToElement(referenceEle);
                }
                else {
                    rid = aTagEle?.getAttribute('refid') as string;
                    const referenceEle: Element | null = this.articleContent.nativeElement.querySelector(
                        "[class='xref tooltips'][rid='" + rid + "']"
                    );
                    // const referenceEle: Element | null = this.articleContent.nativeElement.querySelector(
                    //     "[attr-ref-type='bibr'][rid='" + rid + "']"
                    // );
                    referenceEle?.classList.add("blinking")
                    setTimeout(() => {
                        // Code to be executed after a delay
                        referenceEle?.classList.remove("blinking")
                    }, 2500);
                    this.scrollToElement(referenceEle);
                }


            }
            if (aTagEle.classList[0] === 'inline-graphic') {
                const tagElement = aTagEle.parentNode as HTMLElement
                this.body = tagElement.innerHTML

                this.triggerModal(this.modalData);
            }
        }
    }

    //for setting the article type
    setArticleType(articleType: string) {
        articleType = articleType?.replace(new RegExp('-'), ' ');
        return articleType?.charAt(0).toUpperCase() + articleType?.slice(1);
    }

    //ensures every http/https link inside the given element opens safely in a new tab
    private secureExternalLinks(container: ParentNode) {
        const links = container.querySelectorAll('a[href]');
        links.forEach(link => {
            const href = link.getAttribute('href');
            if (href && /^https?:\/\//i.test(href)) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }
        });
    }

    //to show tooltip in article contents section
    showTooltip(event: Event) {
        if (isPlatformBrowser(this.platformId)) {
            const aTagEle = event.target as HTMLInputElement;
            const refAttrVal = aTagEle?.getAttribute('attr-ref-type') as string;
            if (aTagEle.className == 'xref' && refAttrVal == 'bibr') {
                this.tooltipStatus = 'index';
                const rid = aTagEle?.getAttribute('rid') as string;
                const referenceEle = document.querySelector(
                    "[class='ref'][id='" + rid + "']"
                );
                if (referenceEle) {
                    const refDetail = referenceEle.querySelector(
                        "[class='mixed-citation']"
                    );
                    // aTagEle.setAttribute('class', 'tooltips');
                    aTagEle.classList.add('tooltips');
                    let detail = '';
                    detail = "<span class='ref-pop-heading'>Reference</span>";
                    detail =
                        detail +
                        "<div class='ref-tooltip'>" +
                        refDetail?.innerHTML +
                        '</div>';
                    detail =
                        aTagEle.innerText +
                        "<span class='tooltiptext1'>" +
                        detail +
                        '</span>';
                    aTagEle.innerHTML = detail;
                    this.secureExternalLinks(aTagEle);
                }
            }
            if (aTagEle.className == 'xref' && refAttrVal == 'fn') {//for footnotes
                this.fn_group = true;
                this.tooltipStatus = 'index';
                const fid = aTagEle?.getAttribute('rid') as string;
                const referenceEle = document.querySelector(
                    "[class='fn'][id='" + fid + "']"
                );
                if (referenceEle) {
                    const fnHeadings = referenceEle.querySelectorAll("[class='p']");

                    aTagEle.classList.add('tooltips');
                    aTagEle.setAttribute('data-placement', 'bottom');
                    let detail = '';
                    fnHeadings.forEach(each_fn_p => {
                        const refAttr = each_fn_p?.querySelectorAll("[class='xref']");
                        let refdetaildata = ''
                        refAttr?.forEach(ele => {
                            const rid = ele?.getAttribute('rid') as string;
                            const reference_rid_ele = document.querySelector(
                                "[class='ref'][id='" + rid + "']"
                            );
                            if (reference_rid_ele) {
                                const refDetail = reference_rid_ele.querySelector(
                                    "[class='mixed-citation']"
                                );
                                refdetaildata =
                                    refdetaildata +
                                    // "<div class='ref'>" +
                                    // fnHeading?.innerHTML +
                                    "<p attr-ref-type='bibr' rid='" + rid + "'>" + refDetail?.innerHTML + "</p>";
                                //         '</div>';
                            }

                            ele.removeAttribute('attr-ref-type');
                        })
                        detail += "<span class='ref-pop-heading'>" + each_fn_p?.innerHTML + "</span>" + "<div class='ref-tooltip'>" + refdetaildata + '</div>';
                    });
                    // const refAttr = fnHeading?.querySelectorAll("[class='xref']");
                    // refAttr?.forEach(ele => {
                    //     const rid = ele?.getAttribute('rid') as string;
                    //     const reference_rid_ele = document.querySelector(
                    //         "[class='ref'][id='" + rid + "']"
                    //     );
                    //     if (reference_rid_ele) {
                    //         const refDetail = reference_rid_ele.querySelector(
                    //             "[class='mixed-citation']"
                    //         );
                    //         detail =
                    //             detail +
                    //             // "<div class='ref'>" +
                    //             // fnHeading?.innerHTML +
                    //             "<p attr-ref-type='bibr' rid='" + rid + "'>" + refDetail?.innerHTML + "</p>";
                    //         //         '</div>';
                    //     }
                    //     ele.removeAttribute('attr-ref-type');
                    // })
                    // detail = "<span class='ref-pop-heading'>" + fnHeading?.innerHTML + "</span>" + "<div class='ref-tooltip'>" + detail + '</div>';
                    const spanElement = document.createElement('span');
                    spanElement.classList.add('tooltiptext1');
                    spanElement.innerHTML = detail;
                    this.secureExternalLinks(spanElement);
                    aTagEle.appendChild(spanElement);
                }
            }
        }
    }

    triggerModal(content: ElementRef<HTMLElement>) {
        this.modalservice
            .open(content, { ariaLabelledBy: 'modal-content', size: 'xl' })
            .result.then(
                (res) => {
                    this.modalclose = `Closed with: ${res}`;
                },
                (res) => {
                    this.modalclose = `Dismissed ${this.getDismissReason(res)}`;
                }
            );
    }

    private getDismissReason(reason: ModalDismissReasons): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    modalClose() {
        this.modalservice.dismissAll();
    }

    leaveTooltip(event: Event, type: string) {
        if (type == 'content') {
            const classList = [
                'tooltips',
                'ref',
                'tooltiptext1',
                'ref-pop-heading',
                'ext-link',
                'italic',
                'person-group',
                'name',
                'surname',
                'given-names',
                'article-title',
                'source',
                'year',
                'volume',
                'elocation-id',
            ];
            if (classList.includes((event.target as HTMLInputElement).className)) {
                this.tooltipStatus = 'index';
            } else {
                this.tooltipStatus = '';
            }
        } else {
            const classList = [
                'pt-1 detail',
                'credit_taxonomy pt-1',
                'popover-orcid pt-1',
                'affil',
                'aff',
                'd-inline-block',
                'credit_taxonomy pt-1',
                'd-inline-block',
                'authorpopup-sub-heading',
                'pt-1 affil',
                'tooltiptext',
                'ref-pop-heading',
                'tooltips affiliation-popover-content',
            ];
            if (
                classList.includes((event.target as HTMLInputElement).className)
            ) {
                this.authorStatus = 'index';
            } else {
                this.authorStatus = '';
            }
        }
    }
    // resetDownloadData() {
    //     this.downloadingData = [];
    //     this.disableBtnPdf = false;
    //     this.disableBtnXml = false;
    //     this.downloadCount = -1

    // backToFasttrack() {
    //     this.router.navigate(
    //         ['/articles/fasttrack/page/' + '1'],
    //         {}
    //     );
    // }

    downloadPdf(download_type: string) {
        this.downloading = true;
        const artFilePath = this.articlelist.art_file_path; // Replace with your actual variable

        // download_type == 'pdf'
        //     ? (this.disableBtnPdf = true)
        //     : (this.disableBtnXml = true);

        const params = {
            doi: this.articlelist.doi,
            published_date: this.articlelist.published_date,
            journal_id: this.articlelist.journal_id,
            journal_title: this.articlelist.journal_title,
            volume: this.articlelist.volume_id,
            issue: this.articlelist.issue_id,
            article_id: this.articlelist.article_id,
            article_title: this.articlelist.article_title,
            art_file_path: this.articlelist.art_file_path,
            download_type: download_type,
        };
        setTimeout(() => {
            if (isPlatformBrowser(this.platformId)) {
                this.articleService.articleDownloadCount(params).subscribe({
                    next: (data: Blob) => {
                        this.downloadCount = this.downloadCount + 1;
                        // Split the string by slashes and select the last word
                        const words = artFilePath.split('/');
                        const lastWord = words[words.length - 1];
                        const downloaddata = {
                            filename: lastWord + '.' + download_type,
                            download: true,
                        };
                        this.downloadingData.push(downloaddata);
                        // this.downloading = true;
                        const element = document.querySelector('#liveToast');
                        if (element) element.classList.add('show');
                        const blob = new Blob([data], {
                            type: 'application/pdf/xml',
                        });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = downloaddata.filename;
                        a.click();
                        if (this.downloadingData[this.downloadCount] != undefined)
                            this.downloadingData[this.downloadCount].download =
                                false;
                        this.downloading = false;
                        this.disableBtnPdf = false;
                        this.disableBtnXml = false;
                        setTimeout(() => {
                            if (element && this.downloading == false) {
                                element.classList.remove('show');
                                this.downloadingData = [];
                                this.downloadCount = -1;
                            }
                        }, 10000);
                        if (download_type == 'pdf') {
                            window.open(this.env.articleImage + '/' + this.articlelist.art_file_path + '/' + lastWord + '.' + download_type);
                        }
                    },
                    error: () => {
                        const words = artFilePath.split('/');
                        const lastWord = words[words.length - 1];
                        const downloaddata = {
                            filename: lastWord + '.' + download_type,
                            download: true,
                        };
                        this.downloadingData.push(downloaddata);
                        this.pdfExit = true;
                        const element = document.querySelector('#liveToast');
                        if (element) element.classList.add('show');
                        setTimeout(() => {
                            if (element) {
                                element.classList.remove('show');
                                this.pdfExit = false;
                                this.downloading = false
                            }
                        }, 5000);
                    },
                });
            }
            // this.fetchAnalyticsData();
        }, 500);
        gtag('event', 'download_file', {
            'event_category': 'Downloads',
            'event_label': 'File.pdf'
        });
    }

    viewPdf(download_type: string) {
        const params = {
            art_file_path: this.articlelist.art_file_path,
            download_type: download_type,
        };
        const lastSlashIndex = this.articlelist.art_file_path.lastIndexOf('/');
        const filename = this.articlelist.art_file_path.substring(lastSlashIndex + 1);

        this.articleService.checkFileExist(params).subscribe(result => {
            if (result.status == 200) {
                if (download_type == 'pdf') {
                    if (isPlatformBrowser(this.platformId)) {
                        window.open(this.env.articleImage + '/' + this.articlelist.art_file_path + '/' + filename + '.pdf');
                    }
                }
            }
            else {
                if (isPlatformBrowser(this.platformId)) {
                    this.pdfNotexist = 'The PDF ' + filename + ' could not be found.';
                    const element = document.querySelector('#pdfText');
                    if (element) element.classList.add('show');
                    setTimeout(() => {
                        if (element) {
                            element.classList.remove('show');
                            this.pdfNotexist = '';
                        }
                    }, 10000);
                }
            }
        })
    }
    downloadcount(count: number) {
        this.downloadCount = count;
    }

    downloadFile(files: string) {
        if (isPlatformBrowser(this.platformId)) {
            this.downloadCount = this.downloadCount + 1;
            this.filename = files;
            const downloaddata = {
                filename: this.filename,
                download: true,
            };
            // this.downloadingData.push(downloaddata);
            (this.article_id = this.articlelist.article_id),
                (this.journalId = this.articlelist.journal_id),
                (this.volume_id = this.articlelist.volume_id),
                (this.issue = this.articlelist.issue_id);
            files ? (this.disableBtnPdf = true) : (this.disableBtnXml = true);
            this.downloading = true;
            this.downloadingData.push(downloaddata);
            // this.downloadCount = this.downloadingData.length;
            const element = document.querySelector('#liveToast');
            if (element) element.classList.add('show');
            const params: downloadFile = {
                filename: files,
                article_id: this.articlelist.article_id,
                journal_id: this.articlelist.journal_id,
                volume: this.articlelist.volume_id,
                issue: this.articlelist.issue_id,
            };

            setTimeout(() => {
                this.articleService.downloadFile(params).subscribe({
                    next: (data: Blob) => {
                        const blob = new Blob([data], {
                            type: 'application/pdf/xml',
                        });
                        if (isPlatformBrowser(this.platformId)) {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            // a.download = 'downloaded.' + download_type;
                            a.click();
                            if (this.downloadingData[this.downloadCount] != undefined)
                                this.downloadingData[this.downloadCount].download =
                                    false;
                            this.downloading = false;
                            this.disableBtnPdf = false;
                            this.disableBtnXml = false;
                            setTimeout(() => {
                                if (element && this.downloading == false) {
                                    element.classList.remove('show');
                                    this.downloadingData = [];
                                    this.downloadCount = -1;
                                }
                            }, 10000);
                        }
                    },
                    error: () => {
                        //   console.error('HTTP Error:', error);
                    },
                });
            }, 500);
        }
    }



    setPageNumber(fpage: string, lpage: string) {
        if (fpage === lpage) {
            return fpage;
        } else {
            return fpage + ' - ' + lpage;
        }
    }
    openDyslexic(mode: string) {
        if (mode !== this.viewActiveIcon) {
            this.viewActiveIcon = mode
            this.contentLoaded.nativeElement.classList.toggle('dyslexic-regular');
            this.scrollingTitleSection.nativeElement.classList.add('dyslexic-regular');
        }
        if (mode == 'normal') {
            this.scrollingTitleSection.nativeElement.classList.remove('dyslexic-regular');
        }
    }

    imgStyleChange(secid: string) {
        if (isPlatformBrowser(this.platformId)) {
            const secEle = document.querySelector(
                "[id='" + secid.slice(0, -4) + "']"
            );
            secEle ? this.scrollToElement(secEle) : this.getAndScrollToElement(secid);
        }
    }
    getAndScrollToElement(id: string) {
        if (isPlatformBrowser(this.platformId)) {
            const pageElement = document.getElementById(id)
            if (pageElement?.classList.contains('carousel-images')) {
                this.setTheCarouselImage(pageElement);
            }
            // this.selectedImage=pageElement
            setTimeout(() => {
                if (pageElement) {
                    window.scrollTo({
                        top: pageElement.offsetTop + 480,
                        behavior: 'smooth',
                    });
                }
            }, 500);
        }
    }
    navigateToTable(secid: string) {
        if (isPlatformBrowser(this.platformId)) {
            const secEle = document.querySelector("[id='" + secid + "']");
            this.scrollToElement(secEle);
        }
    }
    //  articlesData: { status: number; articles: any[] };
    articlesData: { status: number; articles: any[] } = {
        status: 0,
        articles: [],
    };

    fetchDataFromApi(article_id): void {
        const fetchdatasubs = this.articleService.fetchRelatedData(article_id).subscribe(
            (response: { status: number; articles: any[] }) => {
                this.articlesData = {
                    status: 0,
                    articles: [],
                }
                this.articlesData = response;
                // this.articlesData.articles = Array.from(new Set(this.articlesData.articles));
                this.totalArticles = response.articles.length;
            },
            // (error) => {
            // console.error('Error fetching data:', error);
            // Handle errors
            // }
        );
        this.subscriptionArr.push(fetchdatasubs);
    }

    loadMoreArticles(section: string): void {
        if (section == 'page_view') {
            // Increase the count of initially displayed articles
            // this.initialArticleCount += 2; // You can adjust this number as per your requirement
            this.showLessFlag = true;
            //this.loadMoreFlag = false;
        }
        else {
            // Increase the count of initially displayed articles
            // this.intialarticleCountInTab += 2; // You can adjust this number as per your requirement
            this.showLessFlagTab = true;
            //this.loadMoreFlag = false;
        }
    }

    showLessArticles(section: string): void {
        if (section == 'page_view') {
            // Reset the count of initially displayed articles
            this.initialArticleCount = 2;
            this.showLessFlag = false;
            //this.loadMoreFlag = true;
        }
        else {
            // Reset the count of initially displayed articles
            this.intialarticleCountInTab = 2;
            this.showLessFlagTab = false;
            //this.loadMoreFlag = true;
        }
    }


    monthName(monthNumber: number): string {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return months[monthNumber - 1];
    }

    getAuthorNames(authors): string {
        return authors.map((a) => a.given_name + ' ' + a.surname).join(', ');
    }

    getRelatedArticleImageUrl(realted_article) {
        let url = '';
        url =
            realted_article.volume +
            '/' +
            realted_article.issue +
            '/' +
            realted_article.article_id +
            '/' +
            realted_article.article_cover_image;
        return url;
    }
    setActiveTab(tab: string) {
        this.activeTab = tab;
        if (tab === 'tab2') {
            setTimeout(() => {
                if (typeof _altmetric_embed_init === 'function') {
                    _altmetric_embed_init();
                }
                if (typeof __dimensions_embed !== 'undefined' && __dimensions_embed.addBadges) {
                    __dimensions_embed.addBadges();
                }
                // if (typeof Crossmark !== 'undefined' && Crossmark.init) {
                //     Crossmark.init();
                // }
            }, 500);
        }
        if (tab === 'tab8') {
            const refElementeRefDiv = this.articleContent.nativeElement.getElementsByClassName("ref-list")
            const lastElement = refElementeRefDiv[refElementeRefDiv.length - 1];
            this.referenceData = lastElement;
        }
    }
    openDropdown(menuType: string) {
        if (isPlatformBrowser(this.platformId)) {
            // this.getDynamicMenusJournal(this.journal_id_jba);
            const parentElement = document.querySelector(`.dropdown-${menuType}`);
            if (parentElement) {
                const dropdownMenu = parentElement.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.add('show');
                    this.titleShared = this.articlelist.article_title
                    this.sharedUrl = `${this.env.siteUrl}/articles/${this.articlelist[4]?.volume}/${this.articlelist[4]?.issue}/${this.articlelist[4]?.article_id}`;
                }
            }
        }
    }

    closeDropdown(menuType: string) {
        if (isPlatformBrowser(this.platformId)) {
            const parentElement = document.querySelector(`.dropdown-${menuType}`);
            if (parentElement) {
                const dropdownMenu = parentElement.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('show');
                }
            }
        }
    }
    viewCitetion() {
        this.imageModal = false;
        this.citeModal = !this.citeModal;

        //  this.triggerModal(this.modalData)
    }


    openCrossmark() {
        const doc = document as any;
        if (doc.CROSSMARK && doc.CROSSMARK.show) {
            doc.CROSSMARK.show();
        } else {
            // Retry once after a short delay in case script is still loading
            setTimeout(() => {
                if (doc.CROSSMARK && doc.CROSSMARK.show) {
                    doc.CROSSMARK.show();
                } else {
                    const doi = this.articlelist.doi;
                    const url = `https://crossmark.crossref.org/dialog?doi=${doi}&domain=pdf`;
                    window.open(url, 'crossmark-dialog', 'width=550,height=550,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
                }
            }, 500);
        }
    }

    // getRelatedArticlePageUrl(realted_article) {
    //     let url = '';
    //     url =
    //         realted_article.journal_id +
    //         '/articles/' +
    //         realted_article.volume +
    //         '/' +
    //         realted_article.issue +
    //         '/' +
    //         realted_article.article_id;
    //     return url;
    // }

    /**
     * Add javascript library to Element
     * @param src:path to js file  
     * @param type:type of the js file 
     * @returns Add element to document body
     */
    addJsToElement(src: string, type: string): HTMLScriptElement | null {
        if (isPlatformBrowser(this.platformId)) {
            const script = document.createElement('script');
            script.type = type;
            script.src = src;
            script.async = true;
            script.defer = true;
            this.renderer.appendChild(document.head, script);
            this.meta.updateTag(
                { name: 'dc.identifier', content: "10.5555/12345678" },
            );
            return script;
        }
        return null;
    }

    public setCitationAuthor(authors) {
        return authors.flatMap(author => [
            {
                name: 'citation_author',
                content: this.stripHtmlTags(`${author.given_name} ${author.surname}`)
            },
            {
                name: 'citation_author_affiliation',
                content: this.stripHtmlTags(author.notes[0]?.notes || '')
            }
        ]);
    }

    private stripHtmlTags(text: string): string {
        return text.replace(/<[^>]*>/g, ''); // Removes all HTML tags
    }

    private formatCitationDate(dateStr: string): string {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
            return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    }
    injectJsonLd(schema: any): void {
        if (isPlatformBrowser(this.platformId)) {
            const existingScript = this.document.head.querySelector('#schema-org-jsonld');
            if (existingScript) {
                existingScript.remove();
            }

            const script = this.renderer.createElement('script');
            this.renderer.setAttribute(script, 'type', 'application/ld+json');
            this.renderer.setAttribute(script, 'id', 'schema-org-jsonld');
            script.text = JSON.stringify(schema);
            this.renderer.appendChild(this.document.head, script);
        }
    }


    public createMetadataforSEONew(articledata) { //console.log("articledata: ", articledata)
        this.meta.addTags([
            { name: 'citation_title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
            { name: 'citation_abstract', content: articledata.abstract.replace(/<[^>]*>/g, '') },
            { name: 'citation_journal_title', content: articledata.journal_title },
            { name: 'citation_doi', content: articledata.doi },
            { name: 'article_type', content: articledata.article_type },
            { name: 'citation_volume', content: articledata.volume_id },
            { name: 'citation_issue', content: articledata.issue_id },
            { name: 'citation_publisher', content: articledata.publisher_name },
            { name: 'article_publisher_location', content: articledata.publisher_loc },
            ...this.setCitationAuthor(articledata.authors),
            { name: 'article_subject_heading', content: articledata.subject_heading },
            { name: 'citation_keywords', content: articledata.keywords != undefined ? articledata.keywords.join(';') : '' },
            { name: 'article_meta', content: articledata.article_meta != undefined ? articledata.article_meta : '' },
            { name: 'citation_abstract_html_url', content: this.env.siteUrl + 'articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
            { name: 'citation_article_url', content: this.env.siteUrl + 'articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
            { name: 'citation_publication_date', content: articledata.published_date ? this.formatCitationDate(articledata.published_date) : '' },
            { name: 'citation_pdf_url', content: articledata.art_file_path ? this.env.articleImage + '/' + articledata.art_file_path + '/' + articledata.art_file_path.split('/').pop() + '.pdf' : '' },
            { name: 'citation_firstpage', content: articledata.fpage },
            { name: 'citation_lastpage', content: articledata.lpage },
            { name: 'citation_issn', content: articledata.e_issn },
            { name: 'citation_language', content: 'en' },
        ]);

        const firstThreeLines = articledata.abstract
            .replace(/<[^>]*>/g, '') // Remove HTML tags
            .split(/[.!?]/) // Split into sentences
            .filter(sentence => sentence.trim() !== '') // Remove empty sentences
            .slice(0, 3) // Take the first three sentences
            .join('\n'); // Join with newline
        this.meta.updateTag(
            { property: 'og:url', content: this.env.siteUrl + 'articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
        );
        this.meta.updateTag(
            { property: 'twitter:title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'og:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'twitter:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        // this.meta.updateTag(
        //     { property: 'og:image', content: imageUrl },
        // );
        this.meta.updateTag(
            { property: 'og:type', content: articledata.article_type.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'og:title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'og:description', content: firstThreeLines },
        );
        // this.meta.updateTag(
        //     { property: 'twitter:image', content: imageUrl },
        // );
        // this.meta.updateTag(
        //     { name: 'dc.identifier', content: "10.5555/12345678" },
        // );
        let imageUrls;
        if (articledata.article_cover_image) {
            imageUrls = this.articleCoverImageUrl + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id + '/' + articledata.article_cover_image;
        } else if (articledata.volume_id > '11') {
            imageUrls = this.env.default_article_cover_image_above_11;
        } else if (articledata.volume_id < '11') {
            imageUrls = this.env.default_article_cover_image_upto_11;
        }
        else {
            imageUrls = this.env.defaultImagePath + this.env.default_articleCoverImage;
        }
        this.meta.updateTag(
            { property: 'og:image', content: imageUrls },
        );
        this.meta.updateTag(
            { name: 'dc.identifier', content: articledata.doi },
        );

    }
    public destroyMetaTagsforSEONew() {
        const metaname = ["citation_title",
            "citation_abstract",
            "citation_journal_title",
            "citation_doi",
            "article_type",
            "citation_volume",
            "citation_issue",
            "citation_publisher",
            "article_publisher_location",
            "article_subject_heading",
            "citation_keywords",
            "citation_author",
            "article_subject_areas",
            "citation_author_affliation",
            "article_meta",
            "citation_publication_date",
            "citation_pdf_url",
            "citation_firstpage",
            "citation_lastpage",
            "citation_issn",
            "citation_language",
            "citation_abstract_html_url",
            "citation_article_url",
            "schema"];
        const els: HTMLMetaElement[] = this.meta.getTags('name');
        els.forEach(el => {
            if (metaname.includes(el.name)) {
                this.meta.removeTag('name="' + el.name + '"');
            }
        });
        // this.meta.updateTag(
        //     { property: 'og:url', content: this.env.siteUrl },
        // );
        // this.meta.updateTag(
        //     { property: 'og:title', content: "Journal of the British Academy" },
        // );
        // this.meta.updateTag(
        //     { property: 'og:description', content: "Journal of the British Academy" },
        // );
        // this.meta.updateTag(
        //     { property: 'og:image', content: this.env.imageUrl + "themes/default_logo.png" },
        // );
        this.meta.updateTag(
            { property: 'twitter:title', content: "Journal of the British Academy" },
        );
        this.meta.updateTag(
            { property: 'twitter:description', content: "Journal of the British Academy" },
        );
        this.meta.updateTag(
            { property: 'twitter:image', content: this.env.imageUrl + "themes/default_logo.png" },
        );

    }

    public createMetadataforSEO(articledata) {
        this.meta.addTags([
            { name: 'citation_title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
            { name: 'citation_abstract', content: articledata.abstract.replace(/<[^>]*>/g, '') },
            { name: 'citation_journal_title', content: articledata.journal_title },
            { name: 'citation_doi', content: articledata.doi },
            { name: 'article_type', content: articledata.article_type },
            { name: 'citation_volume', content: articledata.volume_id },
            { name: 'citation_issue', content: articledata.issue_id },
            { name: 'citation_publisher', content: articledata.publisher_name },
            { name: 'article_publisher_location', content: articledata.publisher_loc },
            { name: 'article_subject_heading', content: articledata.subject_heading },
            { name: 'citation_keywords', content: articledata.keywords != undefined ? articledata.keywords.join(';') : '' },
            { name: 'article_meta', content: articledata.article_meta != undefined ? articledata.article_meta : '' },
            { name: 'citation_abstract_html_url', content: this.env.siteUrl + 'articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
            { name: 'citation_article_url', content: this.env.siteUrl + 'articles/' + articledata.volume_id + '/' + articledata.issue_id + '/' + articledata.article_id },
        ]);

        // /**Structured meta data for Rich content */
        // this.schema = {
        //     '@context': 'http://schema.org',
        //     '@type': 'ScholarlyArticle',
        //     "headline": articledata.article_title.replace(/<[^>]*>/g, ''),
        //     // "datePublished": new Date(this.published_date).toISOString(),
        //     'url': this.env.siteUrl + 'articles/' + articledata.article_id,
        //     // 'image': this.env.siteUrl + 'admin/apis/public/assets/article_cover_images/' + this.article_cover_image,
        //     "publisher": {
        //         "@type": "Organization",
        //         "name": "River Valley Technologies Ltd",
        //         "logo": {
        //             "@type": "ImageObject",
        //             "url": this.env.siteUrl + 'admin/apis/public/assets/rvtlogos.png'
        //         }
        //     }
        // }

        /**Faceboof and Twitter meta and opengraph */
        this.meta.updateTag(
            { property: 'og:url', content: this.env.siteUrl + 'articles/' + articledata.article_id },
        );
        this.meta.updateTag(
            { property: 'og:title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'twitter:title', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'og:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
        this.meta.updateTag(
            { property: 'twitter:description', content: articledata.article_title.replace(/<[^>]*>/g, '') },
        );
    }
    /**
     * Delete all the added meta tags for this article
     **/
    public destroyMetaTagsforSEO() {
        const metaname = ["citation_title",
            "citation_abstract",
            "citation_journal_title",
            "citation_doi",
            "article_type",
            "citation_volume",
            "citation_issue",
            "citation_publisher",
            "article_publisher_location",
            "article_subject_heading",
            "citation_keywords",
            "citation_author",
            "article_subject_areas",
            "citation_author_affliation",
            "article_meta",
            "citation_publication_date",
            "citation_pdf_url",
            "citation_firstpage",
            "citation_lastpage",
            "citation_abstract_html_url",
            "citation_article_url"];
        const els: HTMLMetaElement[] = this.meta.getTags('name');
        els.forEach(el => {
            if (metaname.includes(el.name)) {
                this.meta.removeTag('name="' + el.name + '"');
            }
        });
        this.meta.updateTag(
            { property: 'og:url', content: "" },
        );
        this.meta.updateTag(
            { property: 'og:title', content: "" },
        );
        this.meta.updateTag(
            { property: 'og:description', content: "" },
        );
        // this.meta.updateTag(
        //     { property: 'og:image', content: "" },
        // );
        this.meta.updateTag(
            { property: 'twitter:title', content: "" },
        );
        this.meta.updateTag(
            { property: 'twitter:description', content: "" },
        );
        this.meta.updateTag(
            { property: 'twitter:image', content: "" },
        );
    }
    // public loadStructuredMeta(article_data) {
    //     const script = document.createElement('script');
    //     script.type = "application/ld+json";
    //     const content = {
    //         "@context": "https://schema.org",
    //         "@type": "Article",
    //         "headline": article_data.article_title,
    //         "image": [
    //             "https://example.com/photos/1x1/photo.jpg",
    //             "https://example.com/photos/4x3/photo.jpg",
    //             "https://example.com/photos/16x9/photo.jpg"
    //         ],
    //         "datePublished": "2015-02-05T08:00:00+08:00",
    //         "dateModified": "2015-02-05T09:20:00+08:00"
    //     };
    //     script.text = JSON.stringify(content);
    //     this.renderer.appendChild(document.body, script);
    //     return script;
    // }
    // openNavigation(path) {
    //     const url = '/articles/' + path.volume + '/' + path.issue + '/' + path.article_id;
    //     this.router.navigate([url]);
    // }
    toggleExpand() {
        if (isPlatformBrowser(this.platformId)) {
            this.expanded = !this.expanded;
            if (this.expanded) this.titleMsg = false;
            if (this.expanded) {
                this.articleContenteAreaWidth = this.articleContent.nativeElement.offsetWidth;


            }
            setTimeout(() => {
                this.aricleContentAreaWidth = this.aricleContentArea.nativeElement.offsetWidth;
                this.renderer.setStyle(this.scrollingTitleSection?.nativeElement, 'width', (this.htmlContent?.nativeElement.offsetWidth + 15) + 'px');
                this.headingSectionDivLeft = window.innerWidth <= 612 ? 30 : (this.articleOutlinecol?.nativeElement.offsetWidth ?? 0) + 70;

            }, 250);
        }

    }
    setTooltipMsg() {
        this.titleMsg = true;

    }
    refOutlineClick(event) {
        const innerTextParent = this.articleContent.nativeElement.getElementsByClassName('ref');
        Array.from(innerTextParent).forEach((element) => {
            if (element.textContent === event.target.parentElement.innerText) {
                const rid = element.id
                const referenceEle: Element | null = this.articleContent.nativeElement.querySelector(
                    "[attr-ref-type='bibr'][rid='" + rid + "']"
                );
                referenceEle?.classList.add("blinking")
                setTimeout(() => {
                    referenceEle?.classList.remove("blinking")
                }, 2500);
                this.scrollToElement(referenceEle);
            }
        });
    }

    showArticleOutline() {
        this.toggleOutline = !this.toggleOutline;
        // if (this.toggleOutline) {
        //     this.renderer.setStyle(this.smallDeviceOutLine.nativeElement, 'z-index', '50');
        //     this.articleOutlinecol.nativeElement.setAttribute('style', 'display:block !important;  ,max-width:60%;  z-index: 5;transition-timing-function: ease-in;');
        //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'position', 'fixed');
        //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'top', this.scrollingTitleSection ?
        //         this.scrollingTitleSection?.nativeElement.offsetHeight + 80+ 'px' : (this.headerHeight) + 'px');
        //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'width', '60%');
        //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'width', '60%');
        //     this.renderer.setStyle(this.articleOutlin?.nativeElement, 'height', 'max-content !important');
        //     // this.renderer.setStyle(this.articleOutlin.nativeElement, 'margin-top',
        //     //     this.scrollingTitleSection.nativeElement.offsetHeight > 0 ?
        //     //         (this.scrollingTitleSection.nativeElement.offsetHeight - 20) + 'px' : (this.headerHeight + 15) + 'px');
        //     // this.renderer.setStyle(this.articleOutlin.nativeElement, 'width', (this.articleContentAreaColumn.nativeElement.offsetWidth - this.htmlContent.nativeElement.offsetWidth) - 30 + 'px');
        // }
        // else {
        //     this.articleOutlinecol?.nativeElement.removeAttribute('style');
        //     // this.renderer.setStyle(this.articleOutlin.nativeElement,'width','56%');
        // }
    }

    changeIssue(issue: any) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = 'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num = issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if (issue == 'non-issue') {
            outputString = 'Regular articles';
        }

        return outputString;
    }


    // removeZIndex() {
    //     this.htmlContent.nativeElement.classList.remove('z-index');
    // }

    // addZIndex() {
    //     setTimeout(() => {
    //         this.htmlContent.nativeElement.classList.add('z-index');
    //     }, 1000);
    // }

    loadWidgets() {
        if (isPlatformBrowser(this.platformId)) {
            //vimeo widget generation
            Array.from(document.querySelectorAll(`[attr-ext-link-type="vimeoUrl"],[attr-ext-link-type="uri"][attr-specific-use="vimeoUrl"]`)).forEach(function (item) {
                const vimeoLink = item?.getAttribute('href');
                if (vimeoLink) {
                    const vimeo_link_array = vimeoLink.split('/');
                    const vimeo_id = vimeo_link_array['3'];
                    if (vimeo_id != undefined) {
                        const embeded_vimeo_html = '<iframe class="iframeclass" loading="lazy" title="About Us Template" src="' + vimeoLink + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" data-ratio="0.562" data-width="750" data-height="450"></iframe>';
                        const divele = document.createElement('div');
                        divele.classList.add('vimeo_widget');
                        divele.innerHTML = embeded_vimeo_html;
                        // item.innerHTML = embeded_vimeo_html;
                        item.appendChild(divele);
                    }
                }
            });
        }
    }
    changeIssueForCite(issue) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = issue.replace(pattern, '/');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num = issue && issue.match(nextpattern) ? issue.match(nextpattern)[1] : null;
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, issue_num);
        }

        if (issue == 'non-issue') {
            return outputString = '';
        }

        return '(' + outputString + ')';

    }
    setTitle(data: string) {
        if (data.length > 20) {
            const truncatedString = data.substring(0, 30) + "..."; // Add ellipsis to the truncated string
            return truncatedString;
        }
        else {
            return data;
        }
    }
    goToPage(url: string) {
        this.router.navigate([url])
    }

    addToFavourites() {
        this.toggle_favourite = !this.toggle_favourite;
        const favourite: favourites = {
            jnl_id: this.journal_id,
            volume: this.volume_id,
            issue: this.issue_id,
            article_id: this.article_id
        }
        if (this.toggle_favourite) {
            this.alertService.success('Added to favourites');
        }
        else {
            this.alertService.error('Removed from favourites');
        }
        this.favouriteService.setFavourite(favourite);

    }
    navigateToPdfView(path: string) {
        if (path != '') {
            if (isPlatformBrowser(this.platformId)) {
                const fileUrl = this.supplementaryFilesPath + '/' + path;
                window.open(fileUrl, '_blank');
            }
        }

    }
    // getCleanTitle(title: string): string {
    //     console.log(title);
    //     return title.replace(/<[^>]*>/g, '');
    //   }
    getCleanTitle(title: string): string {
        if (!title) return ''; // Handle null, undefined, or empty string
        return title.replace(/<[^>]*>/g, '');
    }
    initCarousel() {
        const groups = document.querySelectorAll('.fig-group[attr-specific-use="carousel"]');
        groups.forEach((group) => {
            const figs = Array.from(group.querySelectorAll('.fig')) as HTMLElement[];
            if (figs.length <= 1) return;

            let current = 0;
            let timer: any;
            const sources = figs.map(fig => {
                const img = fig.querySelector('img')!;

                img.classList.add('carousel-images');
                img.setAttribute('id', img.getAttribute('href') || '');
                return {
                    src: img.getAttribute('src') || '',
                    href: img.getAttribute('href') || ''
                };
            });
            const preview = document.createElement('div');
            preview.className = 'carousel-preview';

            // create image container inside preview
            const imageContainer = document.createElement('div');
            imageContainer.className = 'carousel-image-container';

            const previewImg = figs[0].querySelector('img')!.cloneNode(true) as HTMLImageElement;

            // put image inside the container
            imageContainer.appendChild(previewImg);

            // put container inside preview
            preview.appendChild(imageContainer);

            // initial label + caption
            const initLabel = figs[0].querySelector('.label');
            const initCap = figs[0].querySelector('.caption');
            if (initLabel) preview.appendChild(initLabel.cloneNode(true));
            if (initCap) preview.appendChild(initCap.cloneNode(true));

            // Create and append counter AFTER label and caption
            const counter = document.createElement('div');
            counter.className = 'carousel-counter';
            // Basic styling for the counter
            counter.style.marginTop = '10px';
            counter.style.marginBottom = '5px';
            counter.style.fontSize = '14px';
            counter.textContent = `Image 1 of ${sources.length}`;
            counter.style.display = 'flex';
            counter.style.justifyContent = 'center';
            preview.appendChild(counter);

            const centerThumb = (thumb: HTMLElement) => {
                const trackRect = track.getBoundingClientRect();
                const thumbRect = thumb.getBoundingClientRect();

                const offset =
                    thumbRect.left -
                    trackRect.left -
                    track.clientWidth / 2 +
                    thumbRect.width / 2;

                track.scrollBy({
                    left: offset,
                    behavior: 'smooth'
                });
            };

            const setPreview = (index: number, animate = true) => {
                current = index;

                if (animate) {
                    previewImg.classList.add('fade-out');
                }

                setTimeout(() => {
                    previewImg.src = sources[index].src;
                    previewImg.setAttribute('id', sources[index].href);
                    if (sources[index].href) {
                        previewImg.setAttribute('href', sources[index].href);
                    }

                    const oldLabel = preview.querySelector('.label');
                    const oldCap = preview.querySelector('.caption');
                    if (oldLabel) oldLabel.remove();
                    if (oldCap) oldCap.remove();

                    const label = figs[index].querySelector('.label');
                    label?.classList.add('sec-label')
                    const cap = figs[index].querySelector('.caption');
                    if (label) preview.appendChild(label.cloneNode(true));
                    if (cap) preview.appendChild(cap.cloneNode(true));

                    thumbs.forEach(t => t.classList.remove('active'));
                    const activeThumb = thumbs[index];
                    activeThumb.classList.add('active');

                    // Update counter and ensure it is at the bottom
                    let counter = preview.querySelector('.carousel-counter');
                    if (counter) {
                        counter.textContent = `Image ${index + 1} of ${sources.length}`;
                        // Move to end of container (after new label/caption)
                        preview.appendChild(counter);
                    }

                    centerThumb(activeThumb);

                    previewImg.classList.remove('fade-out');
                }, animate ? 800 : 0);
            };

            const track = document.createElement('div');
            track.className = 'carousel-track';
            track.tabIndex = 0;

            const thumbs: HTMLImageElement[] = [];

            figs.forEach((fig, i) => {
                const thumb = fig.querySelector('img')!.cloneNode(true) as HTMLImageElement;
                thumb.classList.add('carousel-thumb');
                if (i === 0) thumb.classList.add('active');

                thumb.addEventListener('click', () => {
                    setPreview(i);
                    restartAuto();
                });

                thumbs.push(thumb);
                track.appendChild(thumb);
            });

            // arrows
            const prevBtn = document.createElement('button');
            prevBtn.className = 'carousel-arrow left';
            prevBtn.ariaLabel = 'Previous slide';
            prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M41.4 342.6C28.9 330.1 28.9 309.8 41.4 297.3L169.4 169.3C178.6 160.1 192.3 157.4 204.3 162.4C216.3 167.4 224 179.1 224 192L224 256L560 256C586.5 256 608 277.5 608 304L608 336C608 362.5 586.5 384 560 384L224 384L224 448C224 460.9 216.2 472.6 204.2 477.6C192.2 482.6 178.5 479.8 169.3 470.7L41.3 342.7z"/></svg>`;

            const nextBtn = document.createElement('button');
            nextBtn.className = 'carousel-arrow right';
            nextBtn.ariaLabel = 'Next slide'
            nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M598.6 297.4C611.1 309.9 611.1 330.2 598.6 342.7L470.6 470.7C461.4 479.9 447.7 482.6 435.7 477.6C423.7 472.6 416 460.9 416 448L416 384L80 384C53.5 384 32 362.5 32 336L32 304C32 277.5 53.5 256 80 256L416 256L416 192C416 179.1 423.8 167.4 435.8 162.4C447.8 157.4 461.5 160.2 470.7 169.3L598.7 297.3z"/></svg>`;

            const goPrev = () => setPreview((current - 1 + thumbs.length) % thumbs.length);
            const goNext = () => setPreview((current + 1) % thumbs.length);

            prevBtn.onclick = () => { goPrev(); restartAuto(); };
            nextBtn.onclick = () => { goNext(); restartAuto(); };

            preview.appendChild(prevBtn);
            preview.appendChild(nextBtn);



            const restartAuto = () => {
                clearInterval(timer);
            };

            group.innerHTML = '';
            group.appendChild(preview);
            group.appendChild(track);

            // initialize first slide immediately (no fade)
            setPreview(0, false);

            // startAuto();
        });
    }
    onKeyDown(event: KeyboardEvent) {
        const container = event.target as HTMLElement;
      
        if (event.key === 'ArrowRight') {
          container.scrollLeft += 200;
        }
      
        if (event.key === 'ArrowLeft') {
          container.scrollLeft -= 200;
        }
      }
    setTheCarouselImage(pageElement: any) {

        const track = document.querySelector(
            '.fig-group[attr-specific-use="carousel"] .carousel-track'
        ) as HTMLElement;

        if (!track) return;

        const thumbs = Array.from(track.querySelectorAll('img'));

        thumbs.forEach((element, i) => {
            if (pageElement.getAttribute('id') === element.getAttribute('id')) {
                element.classList.add('active');
                element.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest'
                });

                element.click();
            } else {
                element.classList.remove('active');
            }
        });

    }

}